import { single } from "rxjs/operators";
import { AnaColumn, dynamicGrid } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridDetail, gridEditable, gridSimple, createGridConfig, gridMultiple, SettingGrid } from "./gridSettings/gridSettings";
import { environment } from "../../../environments/environment";





export const colonneSoggetto = [
  {
    dataField: 'ragioneSociale',
    dataType: 'string',
    caption: 'Ragione sociale',
    allowEditing: true,
    colWidth: '300',
  },
  {
    dataField: 'codiceFiscale',
    dataType: 'string',
    caption: 'Codice Fiscale',
    colWidth: '110',
    type: 'campo',
  },
  {
    dataField: 'partitaIva',
    dataType: 'string',
    colWidth: '110',
    caption: 'Partita Iva',

    type: 'campo',
  },
  {
    dataField: 'comune',
    colWidth: '240',
    caption: 'Località',
    type: 'campo',
    dataType: 'string',
  },
  {
    dataField: 'indirizzo',
    colWidth: '210',
    caption: 'Indirizzo',
    type: 'campo',
    dataType: 'string',
  },
]

export const colonneSede = [
  /*  {
     dataField: 'tipoAttività',
     dataType: '',
     caption: '',
     allowEditing: true,
     colWidth: '60',
   }, */
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '200',
  },
  {
    dataField: 'comune',
    dataType: '',
    caption: 'Località',
    allowEditing: true,
    colWidth: '100',
  },
  {
    dataField: 'indirizzo',
    dataType: '',
    caption: 'Indirizzo',
    allowEditing: true,
    colWidth: '100',
  },
]

export const colonneAlboCategoria = [
  {
    type: 'campoSpecial',
    editorType: 'dxSelectBox',
    dataField: "idCategoriaAlboGestore",
    caption: "Cat. Albo Gestore", dataType: "",
    colWidth: '50',
    lista: {
      dataSource: 'CategoriaAlboGestore',
      valueExpr: 'id',
      displayExpr: 'descrizione',
      static: false,
    }

  },
  { type: 'campoSpecial', dataField: "descrizione_Full", caption: "Classe Albo Gestore", dataType: "", colWidth: '300', },
  {
    type: 'campoData',
    dataField: "dataInizio",
    caption: "Data Inizio",
    format: "dd/MM/yyyy", editorType: "dxDateBox",
    dataType: "date",
    colWidth: '100',
  },

]

export const colonneAutista = [
  {
    type: 'campo',

    dataField: "nome",
    caption: "Nome", dataType: "",
    colWidth: '50',


  },
  { type: 'campoSpecial', dataField: "cognome", caption: "Cognome", dataType: "", colWidth: '300', },


]

export const generic = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: true,
    colWidth: '60'
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '540'
  },
]


export const settingGridGeneric: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px'
    },
  ],

}


export const campiRicercaAutorizzazioneArea = [
  {
    itemType: "group", colCount: "3", class: "w-100", caption: "", data: [

      {
        type: 'campo',
        dataField: "descrizioneArea",
        caption: 'Descrizione',
        dataType: "text",
        colWidth: '100',
        colVisible: true,
      },

    ],
  }
]


export const campiRicercaAutorizzazioneSoggetti = [
  {
    itemType: "group", colCount: "3", class: "w-100", caption: "", data: [

      {
        type: 'campo',
        dataField: "descrizione",
        caption: 'Descrizione',
        dataType: "text",
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "numero",
        caption: "Numero",
        colWidth: '91',
        colVisible: true,
        dataType: "text",
      },
      {
        type: 'campo',
        dataField: "dataRilascio",
        caption: "Data Rilascio",
        colWidth: '91',
        colVisible: true,
        dataType: "date",

      },
    ],
  }
]


export const tabellaScarichi: AnaColumn[] = [
  {
    itemType: "group", class: '', visible: false, colCount: "1",
    data: [
      { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "Codice", hideOnEdit: false, disableOnUpdate: true, allowEditing: false, },

      {
        type: 'campo', dataField: "idMovimento", colVisible: false, caption: 'Mov.',
        disableOnUpdate: true,
        hideOnEdit: true,
        allowEditing: false,

      },

      {
        type: 'campo',
        dataField: "dataRegistrazione",
        colVisible: true,
        format: "dd/MM/yyyy",
        dataType: "date",
        caption: "Data registr.",
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '75'
      },
      {
        type: 'campo',
        dataField: "oraRegistrazione",
        dataType: "date",
        format: "HH:ss",
        colVisible: true,
        caption: "Ora",
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '40',

      },
      {
        type: 'campo',
        dataField: "numeroFormulario",
        colVisible: true,
        dataType: "",
        caption: "N.Formulario",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },
      {
        type: 'campo',
        dataField: "causale",
        colVisible: true,
        dataType: "",
        caption: "Causale",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '200'
      },
      {
        type: 'campo',
        dataField: "descrMagazzino",
        colVisible: true,
        dataType: "",
        caption: "Magazzino",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '180',

      },

      {
        type: 'campo',
        dataField: "eer",
        colVisible: true,
        dataType: "",
        caption: "EER",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '55'
      },
      {
        type: 'campo',
        dataField: "idStatoFisico",
        colVisible: true,
        dataType: '',
        caption: "SF.",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '30',

      },
      {
        type: 'campo',
        dataField: "riferimentoEER",
        dataType: "",
        caption: "Riferimento",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '76'
      },
      {
        type: 'campo',
        dataField: "idOperazioneRD",
        colVisible: true,
        dataType: "",
        colCaption: 'Op.',
        caption: "Op.smal./rec.",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '40'
      },
      {
        type: 'campo',
        dataField: "pesoCaricato",
        colVisible: true,
        dataType: "number",
        caption: "Peso",
        hideOnEdit: false,
        allowEditing: false,
        disableOnUpdate: true,
        colWidth: '100',
        format: '#0.##',
      },
      {
        type: 'campo',
        dataField: "residuo",
        colVisible: true,

        caption: "Residuo",
        hideOnEdit: false,
        allowEditing: false,
        disabled: true,
        colWidth: '100',
        dataType: 'number',
        format: '#0.##',
      },

      {
        type: 'campo',
        dataField: "pesoScaricato",
        colCaption: 'Scarico',
        caption: 'Peso da scaricare',
        colVisible: true,
        editorType: 'dxNumberBox',
        dataType: 'number',
        format: '#0.##',
        hideOnEdit: false,
        colWidth: '90'

        /* validation:[
          
          {
            type:"compare",
            comparisonTarget:"residuo",
            comparisonType:'<=',
            message:"Il valore inserito non deve superare il pero residuo"
          },
      
        ] */
      },

      {
        type: 'campo',
        dataField: "differenzaPeso",
        caption: 'Diff.Peso',
        colVisible: true,
        editorType: 'dxNumberBox',
        dataType: 'number',
        format: '#0.##',
        hideOnEdit: false,
        colWidth: '100'

        /* validation:[
          
          {
            type:"compare",
            comparisonTarget:"residuo",
            comparisonType:'<=',
            message:"Il valore inserito non deve superare il pero residuo"
          },
      
        ] */
      },
      /* {
        type: 'simpleButton',

        colVisible: true,
        dataField: "selezionaCarico",
        class: 'text-center scarchi-click',
        caption: " ",
        colWidth: 50,
        button: {
          text: 'selezionaCarico',
          name: 'selezionaCarico',
          location: 'after',
          class: 'seleziona-carico',
          event: "selezionaCaricoClick",
          hint: "Seleziona carico da qui",
          icon: 'glyphicon mdi mdi-selection',
          outPutValue: false,

        }
      }, */

      {
        type: 'colsSum',
        dataField: "pesoScaricato",
        colCaption: 'Scaricare',
        caption: 'Totale scaricabile',
        colVisible: true,
        format: '#0.##',
        editorType: 'dxNumberBox',
        dataType: 'number',

      },
      {
        type: 'colsSum',
        dataField: "differenzaPeso",
        colCaption: 'Differenza peso',
        caption: 'Totale diff.peso',
        colVisible: true,
        format: '#0.##',
        editorType: 'dxNumberBox',
        dataType: 'number',

      },


    ]
  },
]

export const scaricoRifiuto: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Movimento di scarico',
      titleForm: 'Lista carichi da abbinare ',
      breadcrumbCaption: '',
      campoTitle: null,
      service: 'scaricoRifiuto',
      api: 'MovimentoRifiuti',
      filterList: '',
      filterEditor: '',
      helpDoc: 'Relazionidicaricoescarico.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 1,


    }

  },



  {
    itemType: "group", groupDataField: 'filtriCarichi', class: '', colCount: "6", caption: 'Filtra carichi:', data: [
      {
        type: 'campoSpecial',
        dataField: "ListaIdTipoCarico",
        caption: "Tipi di carico",
        dataType: "",
        colVisible: false,
        width: '25vw',
        editorType: 'dxTagBox',
        editorClass: 'd-none',
        colSpan: '1',
        disableOnUpdate: true,
        tagBoxList: {
          dataSource: 'TipoCarico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showSelectionControls: true,
          maxDisplayedTags: 2

        }


      },
      {
        type: 'campoSpecial', dataField: "ListaIdPosizioniDiCarico", dataType: "", caption: "Posizioni",
        colVisible: false,
        width: '25vw',
        editorType: 'dxTagBox',
        colSpan: '1',
        disableOnUpdate: true,
        tagBoxList: {
          dataSource: 'PosizioneCausale',
          valueExpr: 'id',
          displayExpr: 'posizioneRifiuto_Descrizione',
          queryString: '?idCausale=$idCausale',
          showSelectionControls: true,
          maxDisplayedTags: 3
        }

      },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },


      {
        type: 'campoSpecial', dataField: "ListaIdMagazzino", dataType: "", caption: "Magazzini",
        colVisible: false,
        width: '25vw',
        colSpan: '1',
        editorType: 'dxTagBox',
        disableOnUpdate: true,
        tagBoxList: {
          dataSource: 'MagazzinoRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?idSede=$idProduttore',
          showSelectionControls: true,
          maxDisplayedTags: 3,
          multiline: false,
        }
      },
      {
        type: 'campoSpecial',
        editorType: 'dxTagBox',
        dataField: "listaHP",
        caption: "Carat.di pericolo",
        dataType: "",
        width: '25vw',
        hideOnEdit: false,
        colSpan: '1',
        disableOnUpdate: true,
        colVisible: false,
        tagBoxList: {
          dataSource: 'Hp',
          valueExpr: 'id',
          displayExpr: 'id',
          showSelectionControls: true,
          maxDisplayedTags: 3

        }

      },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },

      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Riferimento",
        colVisible: false,
        colSpan: '1',
        disableOnUpdate: true,

      },
      {
        type: 'campo', dataField: "riferimentoEERT", dataType: "", caption: "Mostra tutti Rif.EER",
        colVisible: false,
        width: 8.8 + 'vw',
        colSpan: '1',
        editorType: 'dxCheckBox',
        class: 'ms-4'
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "lottoProduzione",
        caption: "Lotto",
        width: '25vw',
        colSpan: '1',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: "Lotto",
          queryString: '/$idLotto_Sede',
          valueExpr: 'id',
          displayExpr: ['numero', 'descrizione'],
          showClearButton: false
        }
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "produttoreMovCarico",
        caption: "Produttore",
        width: '25vw',
        colSpan: '1',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: ['descrizioneSoggetto', 'descrizione'],

          caption: "Lista Produttori",
          queryString: '?NostraAzienda=N',
          componentType: 'dynamicGrid',
          searchExpr: {
            expand: 'Sede',
            headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['DescrizioneSoggetto', 'Descrizione'],

            optionalFilters: {
              IsProduttore: true,
              NsAzienda: true
            },
          },
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Produttore',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid: {
            masterKey: '',
            keyUnique: '',
            mode: null,
            selectionMode: 'detail',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            showFilterSearch: false,
            height: 630,
            showColBlank: false,
            colonne: [
              {
                dataField: 'ragioneSociale',
                dataType: '',
                caption: 'Ragione sociale',
                allowEditing: true,
              },

            ],

          },
          related: ['id|IdProduttoreMovCarico'],
          detailOption: {
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            isEditable: false,
            isRemote: true,
            api: "Sede",
            service: 'generic',
            queryString: '/$idSoggetto?$filter=( isproduttore eq true )'

          },


        }
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "cliente",
        caption: "Cliente",
        width: '25vw',
        colSpan: '1',
        disableOnUpdate: true,
        editorType: 'dxSelectBox',
        tagBoxList: {
          dataSource: "Lotto",
          queryString: '/$idDestinatario',
          valueExpr: 'id',
          displayExpr: 'numero',

        }
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },
      { type: 'empty', dataType: '', dataField: '', caption: '', colSpan: '1' },


      {
        type: 'campoSpecial',
        colVisible: false,
        editorType: 'dxSelectBox',
        dataField: "IdCantiereFuoriUL",
        width: '25vw',
        caption: "Cantiere",
        disableOnUpdate: true,
        lista: {
          dataSource: "Cantiere",
          queryString: '/$IdProduttoreMovScarico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          showDropDownButton: false,
          showClearButton: false,
          placeholder: ' '
        }
      },
      {
        type: 'campo', colVisible: false, dataField: "totaleDifferenzaPesoDaScaricare",
        caption: 'Totale scaricabile',
        width: '4vw',
        disableOnUpdate: true,
        // editorType: 'dxNumberBox',
        // format: '########0.###',
        maxLength: '10'
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "scaricoAutomatico",
        dataType: "",
        caption: "addDatiRifiuto",
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton ',
        button: {

          icon: 'glyphicon mdi mdi-file-replace-outline',
          name: 'scaricoAutomatico',
          text: 'Scarico Autom.',
          location: 'after',
          event: "scaricoAutomatico",
          hint: "Scarica automaticamente le quantità",

        },
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "scaricoPercentuale",
        dataType: "",
        caption: "scaricoPercentuale",
        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton ',
        button: {

          icon: 'glyphicon mdi mdi-percent',
          name: 'scaricoPercentuale',
          text: 'Scarico %',
          location: 'after',
          event: "scaricoPercentuale",
          hint: "Scarica percentuale quantità",

        },
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "scaricoChiusura",
        dataType: "",
        caption: "scaricoChiusura",

        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          text: 'Scarica e chiudi',
          name: 'scaricoChiusura',
          location: 'after',
          event: "scaricoChiusura",
          hint: "Scarica e chiudi i carichi",
          icon: "glyphicon mdi mdi-package-variant-closed",
          outPutValue: false,


        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "svuotaColonnaScarico",
        dataType: "",
        caption: "svuotaColonnaScarico",

        editorClass: 'nica-plaintext-readonly',
        class: 'blueButton',
        button: {
          icon: 'glyphicon bi bi-trash3',
          name: 'svuotaColonnaScarico',
          text: 'Svuota col.',
          location: 'after',
          event: "svuotaColonnaScarico",
          hint: "Svuota la colonna della quantità di scarico e differenza peso",

        },
      },


      {
        type: 'campoDesc',
        colVisible: false,
        dataField: "quantitaKg",
        dataType: "",

        class: 'd-none',
        caption: "Totale da scaricare (Kg)",
        colSpan: '6'
      },


      {
        type: 'campo',
        dataField: "IdProduttoreMovCarico",
        caption: "",
        dataType: "",
        class: 'd-none',
        colSpan: '6'
      },



    ],
  },
  {
    itemType: "group", caption: ' ', colCount: "4",
    groupDataField: 'filtriCarichiAction', class: 'filtri-carichi-action',
    data: [




    ]
  },
  /*
    
          
         
  */




  {
    itemType: "group", caption: '', colCount: "1",
    groupDataField: 'gestioneScarichi',
    data: [



      {
        type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'listaCarichiDaAbbinare',
        colVisible: false,
        dynamic: {
          dataSource: 'MovimentoRifiuti/GetListaCarichiDaAbbinare',
          service: 'tabellaScarichi',
          queryString: '?IdMovimento=$idMovimento&DataRegistrazione=$dataRegistrazione&Ora=$oraRegistrazione&IdProduttoreMovScarico=$idProduttore&EER=$eer&IdStatoFisico=$idStatoFisico',
          autocomplete: false,
          valueExpr: '',
          campoTabRif: '',
          displayExpr: '',
          filter: '',
          componentType: 'dynamicGrid',

          settingGrid: {
            campoTabRif: 'idMovimento', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'contatore',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'multiple',
            sortingMode: 'none',
            remoteOperations: false, //Abilitato per il salvataggio edit e delete e get
            outputData: false,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: true,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            showColBlank: false,
            showFilterSearch: false,
            height: 300,
            bottoniSottoGriglia: false

          },




        }

      },

      {
        type: 'campo', colVisible: false, dataField: "totalePesoScaricato", dataType: "", caption: "Totale scaricato dalla griglia",
        helpText: 'serve solo a me per i test',

        class: 'd-none',




      },

    ]

  },

]

export const elencocarichiAbbinati: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Movimento di scarico',
      titleForm: 'Lista carichi da abbinare ',
      breadcrumbCaption: '',
      campoTitle: null,
      service: 'elencocarichiAbbinati',
      api: 'MovimentoRifiuti',
      filterList: '',
      filterEditor: '',
      helpDoc: 'Relazionidicaricoescarico.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 1,
    }
  },
  /*
   
         
        
 */




  {
    itemType: "group", caption: '', colCount: "1",
    groupDataField: 'gestioneScarichi',
    data: [



      {
        type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'listaCarichiDaAbbinare',
        colVisible: false,
        dynamic: {
          dataSource: 'MovimentoRifiuti/GetListaCarichiDaAbbinare',
          service: 'tabellaScarichi',
          queryString: '?IdMovimento=$idMovimento&DataRegistrazione=$dataRegistrazione&Ora=$oraRegistrazione&IdProduttoreMovScarico=$idProduttore&EER=$eer&IdStatoFisico=$idStatoFisico',
          autocomplete: false,
          valueExpr: '',
          campoTabRif: '',
          displayExpr: '',
          filter: '',
          componentType: 'dynamicGrid',

          settingGrid: {
            campoTabRif: 'idMovimento', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'contatore',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'none',
            sortingMode: 'none',
            remoteOperations: false, //Abilitato per il salvataggio edit e delete e get
            outputData: false,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: true,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            showColBlank: false,
            showFilterSearch: false,
            height: 300,
            bottoniSottoGriglia: false

          },




        }

      },

      {
        type: 'campo', colVisible: false, dataField: "totalePesoScaricato", dataType: "", caption: "Totale scaricato dalla griglia",
        helpText: 'serve solo a me per i test',

        class: 'd-none',




      },

    ]

  },

]

export const altriDatiRifiuto: AnaColumn[] = [

  {
    itemType: "group", caption: "", groupDataField: 'altriDatiRifiuto', colCount: "4", class: ' ', captionClass: 'no-line-caption', data: [


      {
        type: 'campo',
        dataField: 'descrizioneAssegnata',
        dataType: '',
        caption: 'Descr. Assegnata ',
        colSpan: 4,
        nCol: 6,
        class: '',
        colVisible: false,
        showClearButton: true
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "tipoAnalisi",
        editorType: 'dxSelectBox',
        width: '100',
        caption: "Tipo Analisi",
        nCol: '3',
        lista: {
          valueExpr: 'id',
          displayExpr: 'descrizione',
          dataSource: 'tipoAnalisiList',
          static: true,
          showClearButton: false,
          showDropDownButton: true,
          isDefaultOption: false,
          selectFirstElement: false,
        }
      },
      {
        type: 'campo',
        dataField: "analisiNumero",
        caption: "Analisi numero",
        dataType: "",
        maxLength: '15',
        width: '100',
        labelWidth: 97,
        nCol: '3',
        colVisible: false,
      },
      { type: 'empty', dataField: '', dataType: '', caption: '', nCol: '4', },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campoData',
        dataField: "analisiData",
        caption: "Data Inizio",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        maxLength: '15',
        width: '100',
        nCol: '3',
        colVisible: false,
        showClearButton: false,
      },
      {
        type: 'campoData',
        dataField: "analisiScadenza",
        caption: "Data Scadenza",
        labelWidth: 97,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        showClearButton: false,
        width: '100',
        nCol: '3',
        colVisible: false,
      },
      { type: 'empty', dataField: '', dataType: '', caption: '', nCol: '4' },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      { type: 'empty', dataField: '', dataType: '', caption: ' ', colSpan: '4' },

      {
        type: 'campoSpecial', colVisible: true, dataField: "idBasilea",
        width: '70',
        nCol: '3',
        maxLength: '5',
        showClearButton: true,
        disableOnUpdate: true,
        caption: "Reg.1013",
        editorClass: 'text-uppercase',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          service: '',
          dataSource: 'Basilea',
          componentType: 'dynamicGrid',
          autocomplete: false,
          settingGrid: settingGridGeneric,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista dei Cer Basilea',
            name: 'categorie',
            location: 'after',
          }
        },
      },
      {
        type: 'campoSpecial',
        dataField: "idRecup",
        caption: "Tip.DM 5/2/98",
        class: '',
        showClearButton: true,
        disableOnUpdate: true,
        width: '70',
        labelWidth: 97,
        nCol: '3',
        dataType: "",
        maxLength: '8',
        colVisible: false,
        dynamic: {
          valueExpr: '',
          queryString: "?$filter=(contains(elencocer, '$eer'))",
          displayExpr: 'codice',
          service: '',
          costantValue: [{
            key: 'eer',
            value: 'eer'
          }],

          dataSource: 'Recup',
          componentType: 'dynamicGrid',
          autocomplete: false,
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 500,
            colonne: [
              {
                dataField: 'codice',
                dataType: 'string',
                caption: 'Codice',
                allowEditing: true,
                colWidth: '90',
              },
              {
                dataField: 'descrizione',
                dataType: 'string',
                caption: 'Descrizione',
                colWidth: '350',
                type: 'campo',
              },
            ]
          }),




          buttonOption: {
            text: 'Recup',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista elenco codici di recupero',
            name: 'Recup',
            location: 'after',
          },

        },
      },
      { type: 'empty', dataField: '', dataType: '', caption: '', nCol: '4' },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campo',
        dataField: "bod",
        caption: "B.O.D. [mg/L]",
        maxLength: '10',
        nCol: '3',
        format: '########0.###',
        editorType: 'dxNumberBox',
        width: '70',
        colVisible: false,


      },
      {
        type: 'campo',
        dataField: "cod",
        caption: "C.O.D. [mg/L]",
        format: '########0.###',
        editorType: 'dxNumberBox',
        dataType: "",
        maxLength: '10',
        labelWidth: 97,
        nCol: '3',
        width: '70',

        colVisible: false,

      },
      { type: 'empty', dataField: '', dataType: '', caption: '', nCol: '4' },
      { type: 'empty', dataField: '', dataType: '', caption: '' },
    ]
  }
]

export const altriDatiFormulario: AnaColumn[] = [

  {
    itemType: "group", caption: "Altri Dati Formulario", groupDataField: 'altriDatiFormulario', colCount: "1", class: '', data: [
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTipoFormulario", //tipoFormulario era prima 
        editorType: 'dxSelectBox',
        caption: "Transfrontaliero",
        width: '100',
        nCol: '4',
        lista: {
          dataSource: '',
          static: true,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showDropDownButton: true,
          items: [
            /*    { id: 'C', descrizione: 'Cartaceo' },
               { id: 'B', descrizione: 'Bolla' },
               { id: 'V', descrizione: 'ViviFir' },
               { id: 'S', descrizione: 'Servizi' },
             */

            { id: 'IB', descrizione: 'All. IB al reg. 1013/06' },
            { id: 'VII', descrizione: 'All. VII al reg. 1013/06' },
          ]
        }

      },
      {
        type: 'campo', colVisible: false, dataField: "percorso",
        editorType: 'dxTextArea',
        caption: "Percorso",
        maxLength: '255',
        height: '55px',
        width: '100',
        nCol: '10',
      },

      {
        type: 'campo', colVisible: false, dataField: "appunti",
        editorType: 'dxTextArea',
        caption: "Appunti uso interno",
        maxLength: '255',
        width: '100',
        nCol: '10',
        height: '55px',

      },

    ]
  }

]

export const altriDatiPesata: AnaColumn[] = [

  {
    itemType: "group", caption: "Dati pesata", groupDataField: 'altriDatiPesata', colCount: "5", class: '', data: [


      {
        type: 'campo', dataField: "kgLordoPesa", dataType: "", caption: "Lordo Kg",

        format: '######0.###',
        orderGriglia: 8,
        maxLength: "10",
        colVisible: false,
        colWidth: '100',
        nCol: '3',
        width: 100,
        labelVisible: true,
        editorType: 'dxNumberBox',
      },
      {
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataLordoPesa',
        caption: 'Data',
        colVisible: false,
        editorType: "dxDateBox",
        nCol: '2',
        format: "dd/MM/yyyy",
        showClearButton: false,

      },
      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraLordoPesa',
        caption: 'Ora',
        colVisible: false,
        editorType: "dxDateBox",
        nCol: '2',
        width: 40,
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,


      },
      {
        type: 'campo',
        dataField: 'mpLordoPesa',
        dataType: 'number', caption: 'MP',
        maxLength: '16',

        nCol: '2',
      },
      {
        type: 'empty',
        dataField: '',
        dataType: '',
        nCol: '1',
      },

      {
        type: 'campo', dataField: "kgTaraPesa", dataType: "", caption: "Tara Kg",

        format: '######0.###',
        orderGriglia: 8,
        nCol: '3',
        width: 100,
        maxLength: "10",
        colVisible: false,
        colWidth: '100',
        labelVisible: true,
        editorType: 'dxNumberBox',
      },
      {
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataTaraPesa',
        caption: 'Data',
        colVisible: false,
        editorType: "dxDateBox",
        nCol: '2',
        format: "dd/MM/yyyy",
        showClearButton: false,

      },
      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraTaraPesa',
        caption: 'Ora',
        colVisible: false,
        editorType: "dxDateBox",
        nCol: '2',
        width: 40,
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,


      },
      {
        type: 'campo',
        dataField: 'mpTaraPesa',
        dataType: 'number',
        caption: 'MP',
        maxLength: '16',
        nCol: '2',
      },

      {
        type: 'empty',
        dataField: '',
        dataType: '', caption: '',
        nCol: '1',
      },
    ]
  }
]

export const listaSoggetti: AnaColumn[] = [

  {
    itemType: "group", class: '', visible: false, colCount: "1",
    data: [

      {
        type: 'campo', dataField: "idSede", colVisible: true, dataType: "", caption: "Sede", hideOnEdit: false, disableOnUpdate: true, allowEditing: false,
        width: 40,
      },

      {
        type: 'campo',
        dataField: "tipoTrasporto",
        colVisible: true,
        dataType: "",
        caption: "Vettore",
        colWidth: '200',
        allowEditing: false,
        hideOnEdit: true,
        showEditorAlways: false,
        lista: {
          dataSource: 'tipoTrasporto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        }

      },

      {
        type: 'campoSpecial',
        dataField: 'descrizione',
        dataType: '',
        caption: 'Soggetto',
        orderGriglia: 1,
        class: 'm-auto',
        colVisible: true,
        labelVisible: true,
        colWidth: '300',
        disableOnUpdate: true,
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          queryString: "?$filter=(nsAzienda eq false)",
          valueExpr: '',
          displayExpr: 'descrizione', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista Soggetti',
          related: ['id|idSede', 'idSoggetto|idSoggetto', 'numeroIscrizioneAlbo|autorizzazioneAlbo', 'tipoTrasporto|tipoTrasporto', 'codiceFiscale|codiceFiscale'],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Soggetti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista soggetti',
            name: 'CodiciSoggetti',
            location: 'after',

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'detail',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: true, //Cerca Valore e seleziona
            height: 500,
            width: 600,
            showColBlank: false,
            showFilterSearch: false,
            colonne: [
              {
                dataField: 'ragioneSociale',
                dataType: '',
                caption: 'Ragione sociale',
                allowEditing: true,


              },
            ],
          },

          detailOption: {
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            isEditable: false,
            isRemote: true,
            api: "Sede",
            service: 'sede',
            queryString: '/$idSoggetto?$filter=(istrasportatore eq true)',
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'indirizzo',
                dataType: '',
                caption: 'Indirizzo',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'civico',
                dataType: '',
                caption: 'Civico',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'comune',
                dataType: '',
                caption: 'Comune',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'siglaProvincia',
                dataType: '',
                caption: 'Provincia',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
            ]

          },




        }
      },
      {
        type: 'campoSpecial',
        dataField: 'descrizione_2',
        dataType: '',
        caption: 'Azienda',
        orderGriglia: 1,
        class: 'm-auto',
        colVisible: false,
        labelVisible: true,
        colWidth: '350',
        dynamic: {
          dataSource: 'SoggettoSede/GetAllSoggettiAndSedi',
          service: '',
          autocomplete: false,
          filterStatic: '?$filter=(nsazienda eq false)',
          valueExpr: '',
          displayExpr: 'descrizione', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista Soggetti',

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Soggetti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista soggetti',
            name: 'CodiciSoggetti',
            location: 'after',

          },
          related: ['id|idSede', 'numeroIscrizioneAlbo|autorizzazioneAlbo', 'descrizione', 'idSoggetto|idSoggetto'],
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'detail',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 600,
            width: 800,
            showColBlank: false,
            showFilterSearch: true,
            colonne: [
              {
                dataField: 'ragioneSociale',
                dataType: '',
                caption: 'Ragione sociale',
                allowEditing: true,


              },
            ],
          },
          detailOption: {
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            isEditable: false,
            isRemote: true,
            api: "Sede",
            service: 'sede',
            queryString: '/$idSoggetto?$filter=(nsazienda eq false)'

          },



        }
      },
      {
        type: 'campoSpecial',
        dataField: "operatore",
        colVisible: false,
        dataType: "",
        caption: "Operatore",
        colWidth: '100',
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idSoggetto'
          }],
          valueExpr: '',
          queryString: '/$idSoggetto',

          displayExpr: ['nome', 'cognome'],
          dataSource: 'Autista',
          service: 'autista',
          related: ['nome,cognome|descrizione'],
          autocomplete: false,
          checkValue: {
            forceInsert: true,
            checkValueMessage: null
          },
          caption: "Lista operatori soggetto selezionato",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Operatori',
            name: 'Operatori',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            campoTabRif: 'idSede',
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            width: 740,
            showColBlank: true,
            colonne: [
              {
                dataField: 'index',
                dataType: '',
                caption: '',
                colVisible: false,
                allowEditing: false,
                showEditorAlways: false

              },
              {
                dataField: 'id',
                dataType: '',
                caption: '',
                colVisible: false,
                allowEditing: false,
                showEditorAlways: false

              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
                validation: [
                  { type: 'required', message: 'Produttore obbligatorio' }
                ],
              },
              {
                dataField: 'cognome',
                dataType: '',
                caption: 'Cognome',
                allowEditing: true,
                validation: [
                  { type: 'required', message: 'Produttore obbligatorio' }
                ],
              },
              {
                dataField: 'isOperaio',
                dataType: '',
                caption: 'Operaio',
                allowEditing: false,
                showEditorAlways: false,

                colVisible: true,
                trueText: 'Si',
                falseText: 'No'
              },
              {
                dataField: 'isAutista',
                dataType: '',
                caption: 'Autista',
                allowEditing: false,
                showEditorAlways: false,

                colVisible: true,
                trueText: 'Si',
                falseText: 'No'
              },

            ],

          },
        }
      },

      {
        type: 'campo',
        dataField: "idSoggetto",
        colVisible: false,
        caption: '',
        disableOnUpdate: true,
        allowEditing: false,

      },
      {
        type: 'campo',
        dataField: "autorizzazioneAlbo",
        dataType: "",
        colVisible: true,
        caption: "Autorizz./N.Albo",
        colWidth: '180',
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
      },
      {
        type: 'campoSpecial',
        dataField: "targaAutomezzo",
        colVisible: true,
        dataType: "",
        caption: "Tg.Automezzo",
        disableOnUpdate: true,
        colWidth: '100',
        dynamic: {
          costantValue: [{
            key: 'idSoggetto',
            value: 'idSoggetto'
          }],
          valueExpr: '',
          queryString: "/$idSoggetto?$filter=( tipoautomezzo ne 'D'  and issospeso ne true)",
          filterStatic: "",
          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',

          autocomplete: false,
          checkValue: {
            forceInsert: true,
            checkValueMessage: null
          },
          caption: "Lista Automezzi soggetto selezionato",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Automezzo',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            campoTabRif: 'idSede',
            mode: 'row',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            width: 740,
            showColBlank: true,

            colonne: [

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
                validation: [
                  { type: 'required', message: 'Produttore obbligatorio' }
                ],
              },
              {
                dataField: 'targa',
                dataType: '',
                caption: 'Targa',
                allowEditing: true,

                validation: [
                  { type: 'required', message: 'Produttore obbligatorio' }
                ],
              },
              {
                dataField: 'matricola',
                dataType: '',
                caption: 'Matricola',
                allowEditing: true,
              },
              {
                dataType: '',
                colVisible: true, dataField: "tipoAutomezzo", caption: "Tipo",
                hideOnEdit: false,
                lista: {
                  dataSource: 'TipoAutomezzo',
                  displayExpr: 'descrizione',
                  valueExpr: 'id',
                  static: false
                }
              },



            ],

          },
        }
      },
      {
        type: 'campo',
        dataField: "targaRimorchio",
        colVisible: true,
        dataType: "",
        caption: "Tg.Rimorchio",
        hideOnEdit: false,
        disableOnUpdate: true,
        colWidth: '100',
        dynamic: {
          costantValue: [{
            key: 'idSoggetto',
            value: 'idSoggetto'
          }],
          valueExpr: '',
          queryString: "/$idSoggetto?$filter=( tipoautomezzo eq 'D'  and issospeso ne true)",

          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: true,
          searchExpr: {
            valueExpr: 'id',
            fatherDataField: 'trasportatore_Descrizione_Full',

            dataFields: ['targa'],
            related: ['id|idAutista'],
            optionalFilters: {
            },
          },
          checkValue: {
            forceInsert: true,
            checkValueMessage: null
          },
          caption: "Lista Rimorchi soggetto selezionato",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Automezzo',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            campoTabRif: 'idSede',
            mode: 'row',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            showFilterSearch: false,
            repaintChangesOnly: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            width: 740,
            showColBlank: true,

            colonne: [
              {
                dataField: 'index',
                dataType: '',
                caption: ' ',
                allowEditing: false,


              },
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
                validation: [
                  { type: 'required', message: 'Descrizione obbligatoria' }
                ],
              },
              {
                dataField: 'targa',
                dataType: '',
                caption: 'Targa',
                allowEditing: true,

                validation: [
                  { type: 'required', message: 'Targa obbligatoria' }
                ],
              },
              {
                dataField: 'matricola',
                dataType: '',
                caption: 'Matricola',
                allowEditing: true,
              },
              {
                dataType: '',
                colVisible: true, dataField: "tipoAutomezzo", caption: "Tipo",
                hideOnEdit: false,
                lista: {
                  dataSource: 'TipoAutomezzo',
                  displayExpr: 'descrizione',
                  valueExpr: 'id',
                  static: false
                }
              },
              {
                dataField: 'isSospeso',
                dataType: 'boolean',
                showEditorAlways: false,
                caption: 'Stato',
                trueText: 'Non attivo',
                falseText: 'Attivo',
                allowEditing: true,
                defaultValue: false,
                colVisible: false
              },


            ],

          },
        }
      },

      {
        type: 'campo',
        dataField: "numeroNave",
        colVisible: true,
        dataType: "",
        caption: "N.Nave",
        colWidth: '90'
      },
      {
        type: 'campo',
        dataField: "numeroTreno",
        colVisible: true,
        dataType: '',
        caption: "N.Treno",
        colWidth: '90'

      },

      {
        type: 'campo',
        dataField: "quantitàKg",
        colVisible: false,
        dataType: "number",
        caption: "Quantità Kg",
        colWidth: '40'

      },
      {
        type: 'campo',
        dataField: "idSoggetto",
        colVisible: false,
        dataType: "string",
        caption: "idSoggetto",
        colWidth: '40'

      },






    ]
  },
]

export const RitiriGrid: AnaColumn[] = [
  {
    itemType: "group", class: '', visible: false, colCount: "1",
    data: [

      // {
      //   type: 'campo', dataField: "idProduttoreSede", colVisible: false, visible: false, dataType: "", caption: "Sede", hideOnEdit: true, disableOnUpdate: true, allowEditing: false,
      //   width: 40,
      // },
      {
        type: 'campoSpecial',
        dataField: 'descrizioneProduttoreSede',
        dataType: 'number',
        caption: 'Soggetto',
        orderGriglia: 1,
        class: 'm-auto',
        colVisible: true,
        labelVisible: true,
        colWidth: '300',
        disableOnUpdate: true,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [{ type: 'required', message: 'Soggetto obbligatorio' }],
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          queryString: "?$filter=(nsAzienda eq false)",
          valueExpr: '',
          displayExpr: 'descrizione', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'Lista Soggetti',
          related: ['id|idProduttoreSede', 'indirizzo|indirizzoProduttoreSede', 'civico|civicoProduttoreSede', 'comune|comuneProduttoreSede'],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Soggetti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista soggetti',
            name: 'CodiciSoggetti',
            location: 'after',

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'detail',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: true, //Cerca Valore e seleziona
            height: 500,
            width: 600,
            showColBlank: false,
            showFilterSearch: false,
            colonne: [
              {
                dataField: 'ragioneSociale',
                dataType: '',
                caption: 'Ragione sociale',
                allowEditing: true,


              },
            ],
          },

          detailOption: {
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            isEditable: false,
            isRemote: true,
            api: "Sede",
            service: 'sede',
            queryString: '/$idSoggetto?$filter=(isproduttore eq true)',
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'indirizzo',
                dataType: '',
                caption: 'Indirizzo',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'civico',
                dataType: '',
                caption: 'Civico',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'comune',
                dataType: '',
                caption: 'Comune',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'siglaProvincia',
                dataType: '',
                caption: 'Provincia',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
            ]

          },
        },
      },
      // {
      //   type: 'campo',
      //   dataField: "idSoggetto",
      //   colVisible: false,
      //   visible: false,
      //   caption: '',
      //   disableOnUpdate: true,
      //   allowEditing: false,

      // },
      {
        type: 'campo',
        dataType: 'number',
        dataField: "quantita",
        colVisible: false,
        editorType: "dxNumberBox",
        caption: "Quantità",
        colWidth: '100',
        validation: [
          { type: 'required', message: 'Quantità obbligatoria' },
          // { type: "min", value: 1, message: "Quantità inserita non corretta" },
          // {type: 'pattern',value: '^[1-9]\\d*$', message: 'Inserire un numero intero positivo maggiore di zero'}
        ],
      },
      {
        type: 'campo',
        dataField: "indirizzoProduttoreSede",
        colVisible: false,
        visible: false,
        caption: "Indirizzo",
        colWidth: '100',
        allowEditing: false,
        hideOnEdit: true,
        showEditorAlways: false,
      },
      {
        type: 'campo',
        dataField: "civicoProduttoreSede",
        colVisible: false,
        caption: "Civico",
        colWidth: '100',
        allowEditing: false,
        visible: false,
        hideOnEdit: true,
        showEditorAlways: false,
      },
      {
        type: 'campo',
        dataField: "comuneProduttoreSede",
        colVisible: false,
        caption: "Comune",
        colWidth: '100',
        allowEditing: false,
        hideOnEdit: true,
        showEditorAlways: false,
        visible: false,
      },
    ]
  },
]
//------------ movimentiPerRegistroRifiuto ------------------
export const movimentiRegistroRifiuto: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'Registro carico e scarico rifiuti ',
      titleForm: 'Registro carico e scarico rifiuti',
      breadcrumbCaption: 'Registro carico e scarico rifiuti ',
      campoTitle: ['causaleDesc', 'posizioneDesc'],
      service: 'movimentiRegistroRifiuto',
      api: 'MovimentoRifiuti',
      filterList: '?$count=true&$orderby=DataRegistrazione desc & $orderby=Contatore desc',
      filterEditor: '/$',
      helpDoc: 'Registrodicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],

      masterKey: 'id',
      nCol: 2,
      toolbarSettings: {
        service: 'movimentiToolbar',

      }

    }

  },

  {
    itemType: "group", caption: "", class: '', groupDataField: 'dati-generali-movimento', colCount: "4", data: [



      {
        type: 'button',
        colVisible: true,
        orderGriglia: 1,
        colSpan: '4',
        colWidth: 40,
        dataField: "mostraScaricoR",
        class: 'text-center scarchi-click',
        caption: "",
        visible: false,
        hideOnEdit: true,
        button: {
          text: 'mostraScaricoR',
          name: 'mostraScaricoR',
          location: 'after',
          class: 'scarchiClick',
          event: "scarchiClick",
          hint: "Mostra carichi relazionati",
          icon: 'glyphicon  icon-mostra_password',
          outPutValue: false,

        }
      },

      {
        type: 'campo',
        dataField: "contatore",
        dataType: "",
        caption: "N.",
        colVisible: false,
        nCol: '5',
        orderGriglia: 1,
        disableOnUpdate: true,
        showClearButton: false,
        colSpan: 4,
        hideOnEdit: true,
        visible: false
      },
      // 1
      {
        allowFiltering: false,
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataRegistrazione',
        caption: 'Data reg.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        colWidth: '50',
        colAlignment: 'center',
        odataType: 'date',
        odataFilter: 'startswith',
        staticDataField: 'dataRegistrazione',
        orderGriglia: 2,
        width: '80',
        nCol: '3',
        showClearButton: false,
      },
      // 2
      {
        type: 'campo',
        caption: 'Protocollo',
        labelVisible: true,
        colVisible: true,
        dataField: 'protocollo',
        dataType: '',
        orderGriglia: 5,
        colWidth: 50,
        width: '80',
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'protocollo',
      },
      {
        type: 'campo',
        caption: 'Da assegn.',
        labelVisible: true,
        colVisible: false,
        dataField: 'protocolloDaAssegnare',
        dataType: '',
        orderGriglia: 5,
        colWidth: 50,
        width: '80',
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'protocolloDaAssegnare',
      },
      {
        allowFiltering: false,
        type: 'campoData', dataType: 'date', dataField: 'dataFormulario', caption: 'Data FIR',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        class: 'data-doc-fir',
        showClearButton: false,
        colVisible: true,
        odataType: 'date',
        odataFilter: 'endswith',
        staticDataField: 'dataFormulario',
        colWidth: 50,
        width: '80',
        orderGriglia: 3,
        nCol: '3',
      },
      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.FIR',
        maxLength: '20', maxSize: 20, colWidth: 50, disableOnUpdate: false,
        orderGriglia: 2,
        colVisible: true,
        uppercase: true,
        width: '100', class: 'num-fir',
        nCol: '3',
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'numeroFormulario',
      },
      {
        type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Rif.doc.',
        colVisible: true, maxLength: '15', colWidth: '50', width: '100',
        class: 'rif-doc',
        nCol: '3',
        orderGriglia: 3,
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'riferimentoDocumento',
      },
      // da qua ----
      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif. EER",
        /*  width: 4.3 + 'vw', */
        colWidth: '50',
        colVisible: true,
        labelVisible: true,
        nCol: '2',
        maxLength: '10',
        class: 'rif-cer',
        editorClass: 'text-uppercase',
        orderGriglia: 8,
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'riferimentoEER',
      },

      {
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '60',
        colAlignment: 'center',
        orderGriglia: 7,
        nCol: '4',
        width: '1360',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        showClearButton: false,


      },
      {
        type: 'campo', dataField: "quantitaOrigineKg", dataType: "", caption: "Peso In P.",
        format: environment.PRECISION,
        colAlignment: 'right',
        colCaption: 'Kg Part.',
        width: '50',
        orderGriglia: 11,
        nCol: '3',
        maxLength: "8",
        colVisible: true,
        colWidth: '40',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        validation: [
          { type: 'required', message: 'Peso obbligatorio' }
        ]
      },
      {
        type: 'campo', dataField: "quantitaKg", dataType: "number", caption: "Peso netto Kg",
        format: environment.PRECISION,
        colAlignment: 'right',
        colCaption: 'Kg Acc.',
        width: '50',
        orderGriglia: 11,
        nCol: '3',
        maxLength: "8",
        colVisible: true,
        colWidth: '140',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'quantitaKg',
        validation: [
          { type: 'required', message: 'Peso obbligatorio' }
        ]
      },

      {
        type: 'campo', dataField: "quantitaRespinta", dataType: "", caption: "P. Resp.",
        format: environment.PRECISION,
        colAlignment: 'right',
        colCaption: 'Kg Resp.',
        width: '50',
        orderGriglia: 11,
        nCol: '3',
        maxLength: "8",
        colVisible: true,
        colWidth: '40',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        validation: [
          { type: 'required', message: 'Peso obbligatorio' }
        ]
      },

      //
      {
        type: 'campo', dataField: "xSeCarico", dataType: "", caption: "Carico",
        nCol: '15',
        colVisible: true,
        colWidth: 30,
        labelVisible: true,
        colAlignment: 'center',
        attr: "text-align: center",
        //editorType: 'dxCheckBox',
        //class: 'cer-urbano',
        defaultValue: false,
      },


      {
        type: 'campoButton', dataField: "causale_Descrizione", dataType: "", caption: "Causale",
        colVisible: true,
        nCol: '5',
        colWidth: 100,
        orderGriglia: 1,
        disableOnUpdate: true,
        showClearButton: false,
        colSpan: 2,
        width: '100',
      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "number", caption: "SF",
        width: '33',
        colWidth: '40',
        colVisible: false,
        labelVisible: true,
        nCol: '25',
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idStatoFisico',
        maxLength: '1',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Stato Fisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric
        },
      },



      {
        type: 'campoButton', dataField: "posizioneRifiuto_Descrizione", dataType: "", caption: "Posiz",
        colVisible: false,
        nCol: '5',
        colSpan: 2,
        disableOnUpdate: true,
        showClearButton: false,
        width: '100',
        buttons: [{
          text: '',
          name: 'newCausale',
          location: 'after',
          event: "newCausaleButtonClick",
          hint: "Seleziona una nuova causale",
          icon: "glyphicon mdi mdi-playlist-plus",
          outPutValue: false,


        },
        {
          text: '',
          name: 'viewRegistri',
          location: 'after',
          event: "registriCausaleButtonClick",
          hint: "Visualizza Registri",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: false,


        }
        ],
      },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },





      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraRegistrazione',
        caption: 'Ora reg.',

        colVisible: false,
        width: '100',
        editorType: "dxDateBox",
        colWidth: '15',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        nCol: '2',
      },

      {
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.doc.Interno',
        colVisible: false, maxLength: '10', colWidth: '102', orderGriglia: 4, width: '42', nCol: '3',
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },



      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Cliente**/


      {
        type: 'campoSpecial', dataField: "cliente_Descrizione", dataType: "", caption: "Cliente",
        colVisible: false,
        disableOnUpdate: false,
        colSpan: '4',
        nCol: '10',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'cliente_Descrizione',
        labelWidth: 90,
        width: '100',
        editorClass: 'cliente-desc',

        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },

      {
        type: 'campoSpecial', dataField: "contratto_Descrizione", dataType: "", caption: "Contratto",
        colVisible: false,
        disableOnUpdate: false,
        editorClass: 'cliente-desc',
        width: '100',
        nCol: '5',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idContratto',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'CerComponent',

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Contratto',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      {
        type: 'campoSpecial', dataField: "addebito_Descrizione", dataType: "", caption: "Addebiti",
        colVisible: false,
        disableOnUpdate: false,
        class: 'label-soggetti',
        width: '100',
        nCol: '5',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'addebito_Descrizione',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Addebito',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '4' },
      /**Produttore**/


      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Soggetto", dataType: "", caption: "Prod./Detent.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        class: 'disabled-soggetti',
        placeHolder: '',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'produttore_Descrizione_Soggetto',
        validation: [
          { type: 'required', message: 'Produttore obbligatorio' }
        ],
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?NostreAziende=N&TipoAttivita=P',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|produttore_Id_Soggetto', 'descrizione|produttore_Descrizione_Sede',],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,

            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isProduttore eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Sede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: 'custom-47',
        labelWidth: 55,
        class: 'disabled-soggetti',
        /*  placeHolder: 'Digita la ragione sociale o il nome dell\'unità locale di produzione', */
        validation: [
          { type: 'required', message: 'Produttore UL obbligatorio' }
        ],
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'produttore_Descrizione_Sede',
        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali di produzione",
          costantValue: [{
            key: 'produttore_Id_Soggetto',
            value: 'produttore_Id_Soggetto'

          }],
          queryString: '/$produttore_Id_Soggetto?$filter=(isProduttore eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idProduttore', 'numeroIscrizioneAlbo|autorizzazioneProduttore_Numero'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoProduttori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'addElencoProduttori',
          location: 'after',
          disabled: true,
          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei produttori e microraccolta",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '' },


      /***Autorizzazione Produttore ***/


      {
        type: 'campoSpecial', dataField: "autorizzazioneProduttore_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        nCol: '3',
        width: '100',
        /*  placeHolder: 'Digita in numero dell\'autorizzazione', */
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneProduttore_Descrizione_Full',
        dynamic: {
          queryString: "/$idProduttore",
          filterStatic: "",
          displayExpr: 'numero',
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttore'],
          },
          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneProduttore', 'numeroIscrizioneAlbo|produttoreNumeroIscrizioneAlbo'],
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista delle autorizzazioni',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,
            isOdata: false,
            colonne: campiRicercaAutorizzazioneSoggetti,
          })
        }
      },
      {
        type: 'campoSpecial', dataField: "autorizzazioneProduttoreArea_Full",
        dataType: "",
        caption: "Area",
        colVisible: false,
        nCol: '2',
        width: '100',
        /*  placeHolder: 'Digita in numero dell\'autorizzazione', */
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneProduttoreArea_Full',
        dynamic: {
          queryString: "?idAutorizzazione=$idAutorizzazioneProduttore",

          displayExpr: 'descrizioneArea',
          dataSource: "AutorizzazioneArea",
          service: "autorizzazionearea",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttoreArea'],
          },
          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneProduttoreArea'],
          costantValue: [
            {
              key: 'idAutorizzazioneProduttore',
              value: 'idAutorizzazioneProduttore'
            }],

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista delle aree autorizzate',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              {
                type: 'campo',
                dataField: "descrizioneArea",
                caption: 'Area',
                dataType: "text",
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false
          })
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "produttoreAlboCategoria_Descrizione_Full",
        width: '100',
        caption: "N.Albo",
        disableOnUpdate: true,
        class: 'label-soggetti',
        nCol: '35',
        labelWidth: 55,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'produttoreAlboCategoria_Descrizione_Full',
        dynamic: {
          costantValue: [{ key: 'idProduttore', value: 'idProduttore' }],
          valueExpr: '',
          queryString: '/$idProduttore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          componentType: 'dynamicGrid',
          caption: "Categorie iscr. Albo ",
          related: ['id|idProduttoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreProd', 'idCategoriaAlboGestore|idCategoriaAlboGestoreP'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona la lista dell'iscrizione albo`,
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridSimple,
              width: 1000,
              isOdata: false,
              colonne: colonneAlboCategoria
            }),

        }

      },

      {
        type: 'campo',
        caption: 'Tipo',
        labelVisible: true,
        labelColon: false,
        colVisible: false,
        editorType: 'selectBox',
        dataField: 'tipoProduttore',
        dataType: '',
        nCol: 15,
        odataType: 'boolean',
        odataFilter: '=',
        staticDataField: 'tipoProduttore',
        lista: {
          dataSource: '',
          static: true,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showDropDownButton: true,
          items: [

            { id: 'N', descrizione: 'Nuovo Prod' },
            { id: 'P', descrizione: 'Prod.' },
            { id: 'D', descrizione: 'Det.' },
          ]
        }
      },

      /***FIne Autorizzazione Produttore ***/

      /***Cantiere / Magazziono Produttore ***/

      {
        type: 'campoSpecial', dataField: "cantiere_Descrizione", dataType: "", caption: "Cantiere",
        width: '100',
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        editorClass: 'text-uppercase',
        class: '',
        nCol: '5',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'cantiere_Descrizione',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idProduttore?$filter=(isSospeso ne true)",
          displayExpr: 'descrizione',
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Cantieri fuiri unità locale",
          related: ['id|idCantiereFuoriUl'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista dei fuori unità locale',
            name: 'CantiereFuoriUl',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 1000,
            colonne: colonneSede
          }),

        }
      },
      {
        type: 'campoSpecial', dataField: "magazzinoProduttore_Descrizione", dataType: "", caption: "Magaz",
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        width: '100',
        nCol: '5',
        labelWidth: 55,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'magazzinoProduttore_Descrizione',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          related: ['id|idMagazzinoProduttore'],
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Magazzini produttore",
          queryString: '?idSede=$idProduttore',
          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista magazzini del soggetto',
            name: 'magazzinoProduttore',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 800,
            colonne: [
              {
                type: 'campo',
                dataField: "descrizione",
                caption: 'Magazzino',
                dataType: "text",
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false
          }),
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "caricoAutomatico_IdMagazzino",
        colSpan: '4',
        class: 'd-none',
        hideOnEdit: false,
        caption: "",


      },
      /***Fine Cantiere / Magazziono Produttore  ***/

      { type: 'empty', dataField: '', caption: ' ', colSpan: '4' },

      /***Trasportatore ***/
      {
        type: 'campoDesc', dataField: 'trasportoDesc', defaultValue: 'Nessun trasporto', colSpan: '4',
        labelVisible: false, nCol: '10'
      },

      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Soggetto", dataType: "", caption: "Trasportatore",
        nCol: '5',
        colVisible: false,
        labelVisible: true,
        editorClass: 'trasportatore-desc',
        class: 'disabled-soggetti',
        width: '100',
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'trasportatore_Descrizione_Soggetto',
        dynamic: {
          autocomplete: false,
          dataSource: "Soggetto",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Sedi legali trasportatori",
          queryString: '?NostreAziende=N&TipoAttivita=T',

          componentType: 'dynamicGrid',
          related: ['idSoggetto|trasportatore_Id_Soggetto', 'descrizione|trasportatore_Descrizione_Sede', 'id|idTrasportatore'],
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Trasportatore',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isTrasportatore eq true)',

          }
        }

      },
      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Sede", dataType: "", caption: "U.L.",
        colVisible: false,
        labelVisible: true,
        editorClass: 'trasportatore-desc',
        class: 'disabled-soggetti',
        width: '100',
        labelWidth: 55,
        nCol: 'custom-47',
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'trasportatore_Descrizione_Sede',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'ragioneSociale',
          caption: "Lista Sedi legali trasportatori",
          componentType: 'dynamicGrid',
          related: ['id|idTrasportatore', 'descrizione|trasportatore_Descrizione_Sede'],
          costantValue: [{
            key: 'trasportatore_Id_Soggetto',
            value: 'trasportatore_Id_Soggetto'

          }],
          queryString: '/$trasportatore_Id_Soggetto?$filter=(isTrasportatore eq true)',
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Trasportatore',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),

        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoVettori",
        dataType: "",
        nCol: 'auto',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: '',
        button: {
          text: '',
          name: 'addElencoVettori',
          location: 'after',

          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei vettori 1",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatore",
        class: 'd-none',
        caption: "Trasportatore",
        disableOnUpdate: false,
        editorType: '',
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Sede',

          autocomplete: false

        }

      },
      /***FIne Trasportatore ***/

      /**Albo e Categoria Albo Trasportatore**/



      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneTrasportatoreAlbo_Full",
        width: '100',
        caption: "N.Albo",
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneTrasportatoreAlbo_Full',
        nCol: '5',
        dynamic: {

          valueExpr: '',

          queryString: '/$idTrasportatore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,

          caption: "Lista categoria albo del trasportatore selezionato",
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',

          related: ['id|idTrasportatoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreTras', 'idCategoriaAlboGestore|idCategoriaAlboGestoreT'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona la lista dell'iscrizione albo`,
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              isOdata: false
            }),
        }

      },
      /**Automezzi */
      {
        type: 'campoSpecial', colVisible: false, dataField: "automezzo_Descrizione_Full",
        caption: "Motrice",
        width: '100',
        labelWidth: 54,
        disableOnUpdate: true,
        nCol: '25',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'automezzo_Descrizione_Full',
        dynamic: {
          valueExpr: '',
          queryString: "/$idTrasportatore?$filter=( tipoautomezzo ne 'D' )",
          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: false,
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Automezzo',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),
        }

      },
      {
        type: 'campoSpecial', dataField: "rimorchio_Descrizione", dataType: "", caption: "Rimorchio",
        width: '100',
        nCol: '25',
        colVisible: false,
        labelVisible: true,
        labelWidth: 54,
        class: 'rimorchio',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'rimorchio_Descrizione',
        dynamic: {

          dataSource: 'Automezzo',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'targa',
          service: 'automezzo',
          caption: "Lista Automezzi",
          queryString: "/$idTrasportatore?$filter=( tipoautomezzo eq 'D' )",
          related: ['id|idRimorchio'],
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'rimorchio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Rimorchio Automezzo',
            name: 'Rimorchio',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),

        }
      },
      { type: 'empty', dataField: '', },


      /**Autista***/

      {
        type: 'campoSpecial', dataField: "autista_Cognome_Nome", dataType: "", caption: "Autista1",
        width: '100',
        colVisible: false,
        nCol: '5',
        labelVisible: true,
        maxLength: "50",
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autista_Cognome_Nome',
        dynamic: {

          dataSource: 'Autista',
          service: 'autista',
          autocomplete: true,
          searchExpr: {
            fatherDataField: 'trasportatore_Descrizione_Full',

            //expand: 'Sede',
            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idAutista'],
            optionalFilters: {
              isAutista: true,
              //NsAzienda: true
            },
          },
          valueExpr: '',
          displayExpr: ['nome', 'cognome'],
          caption: "Lista Autisti",
          queryString: '/$idTrasportatore?$filter=(isautista eq true)',
          filterStatic: '',
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          related: ['id|idAutista'],
          buttonOption: {
            text: 'Autista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Autista',
            name: 'Autista',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,

            colonne: colonneAutista
          }),

        }
      },

      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_1",
        colVisible: false,
        dataType: "",
        caption: "Oper.1 ",
        colWidth: '100',
        nCol: '25',
        width: '100',
        labelWidth: 54,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'descrizione_Operatore_1',
        dynamic: {
          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore1'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore1'],
          autocomplete: false,
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Operaio',
            name: 'Operatori',
            location: 'after',
          },
          settingGrid: gridSimple

        }
      },

      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_2",
        colVisible: false,
        dataType: "",
        caption: "Oper.2",
        colWidth: '100',
        width: '100',
        nCol: '25',
        labelWidth: 54,
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'descrizione_Operatore_2',
        dynamic: {

          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore2'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore2'],
          autocomplete: false,
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Operaio',
            name: 'Operatori',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },
      { type: 'empty', dataField: '', },


      /* {type: 'campoDesc', dataField: 'carrozzeriemobiliautomezzo', labelVisible: false, nCol: '6',},
      { type: 'campoDesc', dataField: 'carrozzerieMobiliRimorchio', labelVisible: false, nCol: '6', },
       */


      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Destinatario**/
      {
        type: 'campo', colVisible: false, dataField: "idDestinatario",
        editorType: '',
        class: 'd-none',
        colSpan: '4',
        caption: "Destinatario",
        disableOnUpdate: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idDestinatario',

      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Soggetto", dataType: "", caption: "Destinatario",
        nCol: '5',
        width: '100',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        validation: [{ type: 'required', message: 'Destinatario obbligatorio' }],
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'destinatario_Descrizione_Soggetto',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Smaltitori/Destinatari",
          queryString: '?NostreAziende=N&TipoAttivita=S',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|destinatario_Id_Soggetto', 'descrizione|destinatario_Descrizione_Sede', 'id|idDestinatario', 'nsAzienda|AziendeRelazionato'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Destinatario',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=((isDestinatario eq true) or (isSmaltitore eq true))',

          }

        }
      },
      {
        type: 'campo',
        colVisible: false,
        visible: false,
        dataField: 'AziendeRelazionato',
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Sede", dataType: "", caption: "U.L",
        nCol: '5',
        width: '100',
        colVisible: false,
        labelVisible: true,
        labelWidth: 55,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        validation: [{ type: 'required', message: 'Destinatario obbligatorio' }],
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'destinatario_Descrizione_Sede',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'sede',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Smaltitori/Destinatari",
          componentType: 'dynamicGrid',
          related: ['id|idDestinatario', 'nsAzienda'],
          costantValue: [{
            key: 'destinatario_Id_Soggetto',
            value: 'destinatario_Id_Soggetto'

          }],
          queryString: '/$destinatario_Id_Soggetto?$filter=((isDestinatario eq true) or (isSmaltitore eq true))',


          buttonOption: {
            text: 'UL dest',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatario_Descrizione_Full",
        dataType: "",
        caption: "Autorizza",
        colVisible: false,
        width: '100',
        nCol: '3',
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneDestinatario_Descrizione_Full',
        /* placeHolder: 'Digita il Numero dell\'autorizzazione', */
        dynamic: {
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idDestinatario",
          filterStatic: "",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneDestinatario'],


          },

          dataSource: "Autorizzazione",
          service: 'autorizzazione',
          displayExpr: 'numero',
          autocomplete: true,
          valueExpr: '',
          related: ['id|idAutorizzazioneDestinatario'],
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista delle autorizzazioni',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneSoggetti,
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatarioArea_Descrizione", dataType: "", caption: "Area",
        nCol: '2',
        width: '100',

        colVisible: false,
        labelVisible: true,
        class: 'label-soggetti',
        /*  placeHolder: 'Digita il nome dell\'area autorizzata', */
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneDestinatarioArea_Descrizione',
        dynamic: {
          costantValue: [{ key: 'idAutorizzazioneDestinatario', value: 'idAutorizzazioneDestinatario' }],
          componentType: 'dynamicGrid',
          queryString: '?idAutorizzazione=$idAutorizzazioneDestinatario',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          service: 'autorizzazionearea',
          autocomplete: true,
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneArea,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idAutorizzazioneDestinatarioArea'],
          },
          valueExpr: '',
          caption: "Lista delle aree autorizzate",
          related: ['id|idAutorizzazioneDestinatarioArea'],
          buttonOption: {
            text: 'AutorizzazioneArea',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista delle aree autorizzate',
            name: 'AutorizzazioneArea',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneArea,
              isOdata: false
            }),


        }
      },
      {
        type: 'campoSpecial', dataField: "magazzinoDestinatario_Descrizione", dataType: "", caption: "Magaz.",
        width: '100',
        nCol: '5',
        labelWidth: 55,
        colVisible: false,
        labelVisible: true,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'magazzinoDestinatario_Descrizione',
        dynamic: {

          queryString: "?idSede=$idDestinatario",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: '',
          caption: "Lista Magazzini unità locale",

          related: ['id|idMagazzinoDestinatario'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],


          },

          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista magazzini del soggetto',
            name: 'magazzinoDestinatario',
            location: 'after',

          },
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Magazzino',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campoSpecial', dataField: 'idOperazioneRD', dataType: '',
        colCaption: 'Op.',
        caption: 'Op.smalt/recup.',
        colVisible: false,
        width: '40',
        nCol: '3',
        colSpan: 4,
        orderGriglia: 10,
        colWidth: 50,
        editorClass: 'text-uppercase',
        validation: [
          { type: 'required', message: 'Op.smaltim./recup. obbligatoria' }
        ],
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idOperazioneRD',
        dynamic: {
          displayExpr: '',
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          caption: "Lista Modalità di smaltimento",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'OperazioneRD',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: "Seleziona l'elenco delle operazioni di smaltimento",
            name: 'OperazioneRD',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },




      { type: 'empty', colSpan: '4', dataField: '', dataType: '', caption: ' ' },

      /**Intermediario**/



      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Soggetto", dataType: "", caption: "Intermediario",
        width: '100',
        nCol: '5',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'intermediario_Descrizione_Soggetto',
        showClearButton: true,
        dynamic: {
          autocomplete: false,
          dataSource: "Soggetto",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Intermediario",
          queryString: '?NostreAziende=N&TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|intermediario_Id_Soggetto', 'numeroIscrizioneAlbo|iscrizioneAlboIntermediarioAlbo', 'descrizione|intermediario_Descrizione_Sede', 'id|idIntermediario'],

          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Intermediario',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,

            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',

          }
        }

      },
      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Sede", dataType: "", caption: "UL",
        width: '100',
        nCol: 'custom-47',
        colVisible: false,
        labelVisible: true,
        labelWidth: 55,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'intermediario_Descrizione_Sede',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'sede',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Intermediario",
          queryString: '/$intermediario_Id_Soggetto?$filter=(isIntermediario eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idIntermediario', 'numeroIscrizioneAlbo|iscrizioneAlboIntermediarioAlbo'],
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Intermediario',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',

          }
        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoIntermediari",
        dataType: "",
        nCol: '',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: '',
        button: {
          text: '',
          name: 'addElencoIntermediari',
          location: 'after',

          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei vettori 1",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '' },


      /***Intermediario Albo ***/


      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneIntermediarioAlbo_Full",
        width: '100',
        caption: "N.iscrz.Albo",
        colSpan: '4',
        nCol: '5',
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'autorizzazioneIntermediarioAlbo_Full',
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idIntermediario'
          }],
          valueExpr: '',
          queryString: '/$idIntermediario',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          caption: "Lista categoria albo del intermediario selezionato",
          componentType: 'dynamicGrid', // prima 'AnaAlboComponent',
          related: ['id|idIntermediarioAlboCategoria', 'dataInizio|dataIscrizioneAlboI', 'idCategoriaAlboGestore|idCategoriaAlboGestoreI'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona la lista dell'iscrizione all'albo`,
            name: 'albo',
            location: 'after',

          },

        }

      },


    ]
  },



  {
    itemType: "group", caption: "", colCount: "5", class: 'dati-rifiuto ', groupDataField: 'dati-generali-movimento', data: [


      {
        type: 'campoSpecial', dataField: "lotto_Descrizione", caption: "Lotto di prod.",
        colVisible: false,
        labelVisible: true,
        width: '100',
        nCol: '3',
        disabled: true,
        showClearButton: true,
        dynamic: {
          valueExpr: '',
          displayExpr: 'numero',
          queryString: '/$idLotto_Sede',
          costantValue: [
            { key: 'idSede', value: 'idLotto_Sede' },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }
          ],
          dataSource: 'lotto',
          service: 'lotto',
          autocomplete: false,
          popupWidth: '900',
          caption: "Lista Lotti",
          componentType: 'AnaUnitaLocaliComponent',
          related: ['id|idLotto'],
          buttonOption: {
            text: 'lotto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Lotti di produzione',
            name: 'LottoProduzione',
            location: 'after',
          },


        },
      },

      {
        type: 'campo',
        dataField: "descrizioneAssegnata",
        caption: "Descr.Assegnata",
        dataType: "",
        nCol: '10',
        colVisible: false,
        colSpan: '5',
        maxLength: '250'
      },

      {
        type: 'campoSpecial',
        dataField: "caratteristiche_di_pericolo", caption: "Carat.Peric.",
        colVisible: false,
        orderGriglia: 12,
        colSpan: '5',
        width: '100',
        nCol: '10',
        hideOnEdit: false,
        /*
        dynamic: {
          dataSource: 'Hp',
          service: 'generic',
          autocomplete: false,
          displayExpr: '',
          valueExpr: 'id',
          caption: "Lista Caratteristiche di Pericolo",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Caratteristiche Pericolo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Caratteristiche Pericolo',
            name: 'stoccaggio',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridMultiple,
            colonne: generic
          }),

        }*/
      },

      {
        type: 'campo',
        dataField: "caratteristicheChimiche",
        caption: "Carat.chim/fis.",
        dataType: "",
        width: '100',
        maxLength: '255',
        nCol: '9',
        colVisible: false,
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addDatiRifiuto",
        dataType: "",
        caption: "addDatiRifiuto",
        nCol: '2',
        editorClass: 'nica-plaintext-readonly',
        class: '',
        width: 100,
        button: {
          text: 'Altri dati relat.rifiuto',
          name: 'addDatiRifiuto',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati relativi al rifiuto",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campo',
        dataField: "annotazioni",
        caption: "Annotazioni",
        dataType: "",
        colSpan: '5',
        nCol: '10',
        colVisible: false,
        maxLength: '255',

      },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },

      {
        type: 'campo', dataField: "quantitaOrigineKg", dataType: "", caption: "Peso partenza",
        format: environment.PRECISION,
        maxLength: "11",
        hideOnEdit: false,
        colVisible: false,
        labelVisible: true,
        editorType: 'dxNumberBox',
        disabled: true,
        readonly: true,
        nCol: '3'


      },
      {
        type: 'campo', dataField: "verificatoPartenza", dataType: "boolean", caption: "Verificato in partenza",

        colVisible: false,
        labelVisible: true,
        labelColon: false,
        labelPosition: 'right',
        hideOnEdit: false,
        labelWidth: 138,
        editorType: 'dxCheckBox',
        disabled: true,
        readonly: true,
        nCol: '3'
      },

      {
        type: 'campo', dataField: "volume", dataType: "", caption: "Volume ",
        format: '########0.###',
        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        editorType: 'dxNumberBox',
        nCol: '3',
        width: 53
      },
      {
        type: 'campoSpecial', dataField: "unitaMisuraVolume", dataType: "", caption: "MC/LT",
        colVisible: false,
        orderGriglia: 9,
        labelVisible: true,
        width: '120',
        class: 'volumeUm',
        maxLength: '1',
        nCol: '2',
        editorType: 'dxSelectBox',
        disabled: true,
        lista: {
          dataSource: 'umVolume',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          placeholder: ' ',
          widthOnOpened: 200,
          showClearButton: false,
          showDropDownButton: false,
          isDefaultOption: false,
          static: true,
        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "", nCol: '1' },

      {
        type: 'campoSpecial', colVisible: false, dataField: "adr",
        caption: "ADR",
        disabled: true,
        readonly: true,
        width: '100',
        nCol: 3,
        editorType: 'dxSelectBox',

        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          showDropDownButton: true,
          placeholder: 'Si/No',
          static: true,

        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "testoADR_Descrizione",
        width: '100',
        caption: "Testo ADR",
        class: 'testo-adr',
        disabled: true,
        disableOnUpdate: true,
        nCol: 65,
        dynamic: {
          costantValue: [
            { key: 'eer', value: 'eer' }
          ],
          valueExpr: '',

          autocomplete: false,
          displayExpr: 'testo',
          dataSource: 'TestiAdr',
          related: ['id|idTestoADR', 'idClasseAdr', 'idOnu|idONU'],

          service: 'testoAdr',
          caption: "Lista Testi ADR",
          componentType: 'TestiAdrComponent',//'dynamicGrid',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idClasseAdr",
        width: '100',
        maxLength: '6',
        caption: "Classe",
        class: 'classe-adr',
        showClearButton: false,
        disableOnUpdate: true,
        disabled: true,
        nCol: '2',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'Adr',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista Classi ADR",
          componentType: 'dynamicGrid',


          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          }
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idONU",
        width: '100',
        nCol: '2',
        maxLength: '6',
        caption: "Onu",
        showClearButton: false,
        disabled: true,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'onu',
          service: 'generic',
          autocomplete: false,
          caption: "Lista ONU",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          }
        }

      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campoData',
        dataField: "dataInizioTrasporto",
        caption: "Data iniz.trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        nCol: '3',
        maxLength: '15',
        width: '50',
        showClearButton: false,
        colVisible: false,
        disabled: true,
        readonly: true,
      },
      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraInizioTrasporto',
        caption: 'Ora inizio',
        disableOnUpdate: true,

        nCol: '2',
        colVisible: false,
        editorType: "dxDateBox",
        disabled: true,
        readonly: true,
        colWidth: '15',
        width: '100',
        format: 'HH:mm', mask: 'HH:mm', showClearButton: false

      },
      {
        type: 'campoData',
        dataField: "dataFineTrasporto",
        caption: "Data fine trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        disabled: true,
        readonly: true,
        maxLength: '15',
        nCol: '3',
        width: '50',
        colVisible: false,
        showClearButton: false,
        disableOnUpdate: true,
      },
      {
        type: 'campoData', dataType: 'time',
        dataField: 'oraFineTrasporto',
        caption: 'Ora fine',
        class: 'ora-fine',
        disabled: true,
        readonly: true,

        nCol: '2',
        colVisible: false,
        editorType: "dxDateBox",
        colWidth: '15',
        width: '100',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        disableOnUpdate: true,
      },
      { type: 'empty', dataField: '', dataType: '', nCol: '2' },

      {
        type: 'campo',
        dataField: 'numeroColli',
        class: 'quantita-origine',
        width: '100',
        caption: 'N.Colli',
        maxLength: '10',
        editorType: 'dxNumberBox',
        format: '0######',
        disabled: true,
        colVisible: false,
        readonly: true,
        nCol: '3',
      },
      {
        type: 'campoSpecial',
        dataField: 'imballo_Descrizione',
        caption: 'Imballo',
        class: 'imballo',
        width: '100',
        colVisible: false,
        maxLength: '10',
        nCol: '7',

        dynamic: {
          valueExpr: '',
          autocomplete: false,
          displayExpr: 'descrizione',
          dataSource: 'Imballo',
          related: ['id|idImballo'],
          queryString: '',
          service: 'imballo',
          caption: "Lista Imballi",
          componentType: 'ImballiComponent',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Imballaggi',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            mode: 'row',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            height: 500,
            showColBlank: false,



          }
        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "altriDatiFormulario",
        dataType: "",
        class: '',
        caption: "altriDatiFormulario",
        nCol: '2',

        button: {
          text: 'Altri dati formulario',
          name: 'addDatiFormulario',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati formulario",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '5' },

      {
        type: 'campoSpecial',
        dataType: '',
        dataField: 'tipoAccettazione',
        caption: 'Accettazione',
        colVisible: false,
        disabled: true,
        readonly: true,
        width: '100',
        nCol: '3',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'accettazioneTipo',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          showDropDownButton: true,
          placeholder: ' ',


        }

      },
      {
        type: 'campoSpecial', dataField: "idMotivoRespinta", dataType: "", caption: "Motivo resping.",
        labelVisible: true,
        width: '100',
        nCol: '4',
        editorType: 'dxSelectBox',
        disabled: true,
        colVisible: false,
        lista: {
          dataSource: 'MotivazioniRespingimento',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          showClearButton: false,
          placeholder: '',
          showDropDownButton: false,

        }

      },
      {
        type: 'campo', dataField: "descrizioneRespinta", dataType: "", caption: " ",
        disabled: true,
        colVisible: false,
        labelVisible: false,
        class: 'autoLabelWidth',
        placeHolder: 'Specifica il motivo',
        width: '100',
        nCol: '6',

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo', dataField: "quantitaRespinta", dataType: "", caption: "Peso Resp.Kg",
        width: '100',
        format: '',
        nCol: '3',

        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        class: 'peso-respinto',
        editorType: 'dxNumberBox',
      },
      { type: 'empty', dataField: '', dataType: '', nCol: '6' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo', dataField: "scontrino", dataType: "", caption: "N.Scontrino",
        width: '100',
        maxLength: "10",
        colVisible: false,
        colWidth: '100',
        nCol: '3',
        labelVisible: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'scontrino',
      },


      {
        type: 'simpleButton', colVisible: false,
        dataField: "datiPesata",
        dataType: "",
        caption: "datiPesata",
        class: 'dati-pesata',
        nCol: '9',
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: 'Altri dati pesata',
          name: 'addDatiPesata',
          location: 'after',
          event: "addDati",
          hint: "Dati relativi alla pesata",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },



      {
        type: 'campoSpecial', colVisible: false, dataField: "categoriaDocumento_Descrizione",

        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'categoriaDocumento_Descrizione',
        labelVisible: true,
        caption: "Categoria doc.",
        disableOnUpdate: true,
        nCol: 5,
        showClearButton: true,
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Categorie documento",
          componentType: 'dynamicGrid',
          related: ['id|idCategoriaDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idTipoDocumento",
        class: 'd-none',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'soggetti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          related: ['descrizione|tipoDocumento_Descrizione'],


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "tipoDocumento_Descrizione",
        nCol: 5,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'tipoDocumento_Descrizione',
        caption: "Tipo doc.",
        class: 'tipo-doc',
        labelWidth: 77,
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista tipo documento",
          componentType: 'dynamicGrid',
          related: ['id|idTipoDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },


      {
        type: 'campoSpecial', colVisible: false, dataField: "zonaDocumento_Descrizione",

        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'zonaDocumento_Descrizione',
        nCol: 5,
        caption: "Zona doc.",
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista zona documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idZonaDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idZonaDocumento",

        class: 'd-none',
        maxLength: '10',
        caption: "Zona doc.",
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idZonaDocumento',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          componentType: 'grid',
          related: ['descrizione|zonaDocumento_Descrizione'],

        }

      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idBacinoDocumento",
        class: 'd-none',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idBacinoDocumento',
        dynamic: {

          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista tipo documento",
          related: ['descrizione|bacinoDocumento_Descrizione'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "bacinoDocumento_Descrizione",
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'bacinoDocumento_Descrizione',
        nCol: 5,
        caption: "Bacino Doc.",
        disableOnUpdate: true,
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Bacino',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Bacini documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idBacinoDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'bacino',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: '', dataType: '', colSpan: '5', caption: ' ' },

      {
        type: 'campoSpecial',
        dataField: "idCategoriaRaee",
        caption: "Cat.Raee",
        hideOnEdit: true,
        editorType: "dxSelectBox",
        dataType: "",
        visible: true,
        width: '15.5vw',

        colVisible: false,
        lista: {
          dataSource: 'Raee',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        }

      },

      {
        type: 'campo',
        dataField: "tipoRaee",
        caption: "P/D",
        hideOnEdit: true,
        dataType: "",
        editorClass: 'text-uppercase',
        class: 'tipo-raee',
        width: 2 + 'vw',
        colVisible: false,


      },

      {
        type: 'campoSpecial', dataField: 'operazioneVeicoliFuoriUso', dataType: '', caption: 'Attità Veicoli FU',
        editorType: 'dxSelectBox',
        hideOnEdit: true,
        colVisible: false,
        width: '9vw',

        class: 'veicoliFU',
        lista: {
          dataSource: 'operazioneVeicoliFuoriUso',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campoSpecial',
        dataField: "imballaggioRicevuto",
        caption: "Imballaggi",
        hideOnEdit: true,
        dataType: "",
        colVisible: false,
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: 'imballaggioRicevuto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }

      },
      {
        type: 'campoSpecial',
        dataField: "prodottoDaImballaggi",
        caption: "Prov.da imballaggi",
        editorType: 'dxRadioGroup',
        dataType: "",

        hideOnEdit: true,
        class: 'prodottoDaImballaggi',
        colVisible: false,

        radioGroup: {

          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }
      },
      {
        type: 'campo',
        dataField: "isAlluminio",
        caption: "Alluminio",
        editorType: "dxCheckBox",
        dataType: "boolean",
        disableOnUpdate: true,
        colVisible: false,
        defaultValue: false,
        hideOnEdit: true,

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      /**Campi Nascosti**/
      {
        type: 'campo', dataField: "id", dataType: "", caption: "Codice",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',

      },
      {
        type: 'campo', dataField: "causale_Id_Operazione", dataType: "", caption: "Operazione",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',
        colWidth: 90,
      },
      {
        type: 'campoSpecial',
        colVisible: false, dataField: "idAutorizzazioneDestinatario",
        caption: "AutorizzB",
        class: 'd-none',
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: '',

          displayExpr: 'id',
          dataSource: 'Autorizzazione?id=',
          autocomplete: false,

          caption: "Lista Autorizzazioni",
          componentType: 'grid',



        }

      },
      {
        /***Autorizzazione Area destinatario ***/
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneDestinatarioArea",
        class: 'd-none',
        caption: "Autorizz.Area",
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          autocomplete: false,
          related: ['descrizioneArea|autorizzazioneDestinatarioArea_Full'],
          caption: "Lista Autorizzazioni",
          componentType: 'grid',


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idMagazzinoDestinatario",
        hideOnEdit: false,
        class: 'd-none',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idMagazzinoDestinatario',
        caption: "Magazzino.",
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idDestinatario'
          }],
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'MagazzinoRifiuti',
          autocomplete: false,
          //related:['descrizione|magazzinoDestinatario_Descrizione']


        }

      },
      {
        type: 'campo', colVisible: false, dataField: "idIntermediario",
        editorType: '',
        class: 'd-none',
        colSpan: '4',
        caption: "",
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idIntermediario',
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idIntermediarioCategoriaAlbo",
        class: 'd-none',
        colSpan: '4',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idIntermediarioCategoriaAlbo',
        dynamic: {
          valueExpr: '',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idCantiereFuoriUl",
        class: 'd-none',
        colSpan: '4',
        hideOnEdit: false,
        caption: "Cantiere",
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutista",
        colSpan: '4',
        labelVisible: false,
        class: 'd-none',
        nCol: '0',
        caption: "idAutista",

        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idAutista',
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Autista?id=',

          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          related: ['nome,cognome,matricola|autista_Descrizione_Full'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutomezzo",
        caption: "Automezzo",
        class: 'd-none',
        colSpan: '4',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idAutomezzo',
        dynamic: {

          valueExpr: '',
          queryString: 'id',
          dataSource: '',
          displayExpr: 'id',
          autocomplete: false,


        }

      },
      {
        type: 'campoSpecial', dataField: "idRimorchio", dataType: "", caption: "Rimorchio",
        colSpan: '4',
        colVisible: false,
        labelVisible: true,
        class: 'd-none',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idRimorchio',
        dynamic: {
          dataSource: 'Automezzo?id=',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          queryString: '',
          filterStatic: "?$filter=( tipoautomezzo eq 'D' )",
          componentType: 'grid',
          related: ['targa|rimorchio_Targa'], //


        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatoreAlboCategoria",
        class: 'd-none',
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idTrasportatoreAlboCategoria',
        dynamic: {
          valueExpr: 'id',
          displayExpr: '',
          dataSource: 'AlboCategoria',
          autocomplete: false,


        }

      },
      {
        type: 'campo', colVisible: false, dataField: "idTestoADR",
        caption: "ADR",
        dataType: '',
        class: 'd-none',
        colSpan: '5',

      },
      {
        type: 'campo', colVisible: false, dataField: "idLotto",
        class: 'd-none',
        colSpan: '5'
      },
      {
        type: 'campo', colVisible: false, dataField: "idLotto_Sede",
        class: 'd-none',
        colSpan: '5'
      },
      {
        type: 'campo',
        dataField: 'idImballo',
        caption: 'Imballo',
        class: 'imballo d-none',
        colVisible: false


      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idCategoriaDocumento",
        colSpan: 4,
        class: 'd-none',
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista CategoriaDocumento",
          componentType: 'grid',
          related: ['descrizione|categoriaDocumento_Descrizione'],


        }

      },
    ]
  },


]

//----------- END movimentiPerRegistroRifiuto -------------------------
export const movimentiRifiuto: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'Registro carico e scarico rifiuti',
      titleForm: 'Registro carico e scarico rifiuti',
      breadcrumbCaption: 'Registro carico e scarico rifiuti',
      campoTitle: ['causaleDesc', 'posizioneDesc'],
      service: 'movimentiRifiuto',
      api: 'MovimentoRifiuti',
      filterList: '?$orderby=DataRegistrazione desc,Contatore desc',
      filterEditor: '/$',
      helpDoc: 'Registrodicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],

      masterKey: 'id',
      nCol: 2,
      toolbarSettings: {
        service: 'movimentiToolbar',

      }

    }

  },

  {
    itemType: "group", captionClass: 'no-line-caption-bottom', caption: "", colGroup: 55, groupDataField: 'dati-generali-movimento', colCount: "4", data: [
      // {
      //   type: 'button',
      //   colVisible: true,
      //   orderGriglia: 1,
      //   visible: false,
      //   dataField: "copiaComeNuovo",
      //   class: 'text-center p-2',
      //   horizontalAlignment: 'center',
      //   colAlignment: 'center',
      //   odataFilter: '',
      //   button: {
      //     text: 'copiaComeNuovo',
      //     name: 'copiaComeNuovo',
      //     location: 'center',
      //     event: "copiaComeNuovo",
      //     hint: "Crea nuovo movimento da esistente",
      //     icon: 'bi bi-node-plus',
      //   }
      // },
      {
        orderGriglia: 1,
        type: 'campoMultiData',
        colWidth: 40,
        dataField: 'isRentri',
        colVisible: true,
        hideOnEdit: true,
        caption: " ",
        dataType: 'object',
        allowFiltering: false,
      },

      {
        type: 'button',
        colVisible: true,
        orderGriglia: 1,
        colSpan: '4',
        colWidth: 40,
        dataField: "mostraScaricoR",
        class: 'text-center scarchi-click',
        caption: "",
        visible: false,
        hideOnEdit: true,
        button: {
          text: 'mostraScaricoR',
          name: 'mostraScaricoR',
          location: 'after',
          class: 'scarchiClick',
          event: "scarchiClick",
          hint: "Mostra carichi relazionati",
          icon: 'glyphicon  icon-mostra_password',
          outPutValue: false,

        }
      },


      {
        type: 'campo',
        dataField: "contatore",
        dataType: "",
        caption: "N.",
        colVisible: false,
        nCol: '5',
        orderGriglia: 1,
        disableOnUpdate: true,
        showClearButton: false,
        colSpan: 4,
        hideOnEdit: true,
        visible: false
      },

      {
        type: 'campoButton', dataField: "causale_Descrizione", dataType: "", caption: "Causale",
        colVisible: true,
        nCol: '5',
        orderGriglia: 1,
        disableOnUpdate: true,
        showClearButton: false,
        colSpan: 2,
        width: '100',
        labelWidth: 90
      },
      {
        type: 'campoButton', dataField: "posizioneRifiuto_Descrizione", dataType: "", caption: "Posiz",
        colVisible: false,
        nCol: '5',
        colSpan: 2,
        disableOnUpdate: true,
        showClearButton: false,
        width: '100',
        buttons: [{
          text: '',
          name: 'newCausale',
          location: 'after',
          event: "newCausaleButtonClick",
          hint: "Crea nuovo",
          icon: "glyphicon mdi mdi-playlist-plus",
          outPutValue: false,


        },
        {
          text: '',
          name: 'viewRegistri',
          location: 'after',
          event: "registriCausaleButtonClick",
          hint: "Visualizzi i registri",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: false,


        }
        ],
      },
      { type: 'empty', dataField: '', caption: '', colVisible: false },

      {
        allowFiltering: true,
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataRegistrazione',
        caption: 'Data reg.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        // colWidth: '125',
        colAlignment: 'center',
        // orderGriglia: 2,
        odataType: 'date',
        odataFilter: '>=',
        staticDataField: 'dataRegistrazione',
        width: '125',
        nCol: '3',
        showClearButton: false,
        // calendarOptions: {max: new Date()} ,
      },
      {
        allowFiltering: true,
        type: 'campoData', dataType: 'date', dataField: 'dataFormulario', caption: 'Data FIR',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",//!-------------
        class: 'data-doc-fir',
        showClearButton: false,
        odataType: 'date',
        odataFilter: '<=',
        staticDataField: 'dataFormulario',
        colVisible: false,
        // width: '100',
        // orderGriglia: 3,
        // labelWidth: 90,
        nCol: 4,
      },
      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.FIR',
        maxLength: '20', maxSize: 20, colWidth: '124',
        // orderGriglia: 2,
        colVisible: true,
        disableOnUpdate: false,
        uppercase: true, class: 'num-fir',
        disabled: true,
        nCol: '4',
        buttons: [
          {
            name: 'formularioCopy',
            text: 'Ricopia XFIR',
            event: "formularioCopy",
            hint: 'Ricopia documento accompagnatorio',
            icon: 'glyphicon mdi mdi-content-paste'
          },
        ]

      },
      {
        type: 'simpleButton',
        colVisible: false,
        visible: true,
        disabled: true,
        dataField: "addDatiRitiri",
        dataType: "",
        caption: "addDatiRitiri",
        nCol: '3',
        editorClass: 'nica-plaintext-readonly',
        class: 'd-flex justify-content-end',
        // width: 100,
        button: {
          text: 'Dettaglio Ritiri',
          name: 'addDatiRitiri',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati relativi ai ritiri",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      {
        type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Rif.doc.',
        colVisible: true, maxLength: '15', colWidth: '130', width: '100',
        class: 'rif-doc',
        nCol: 26,
        orderGriglia: 3,
      },

      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraRegistrazione',
        caption: 'Ora reg.',

        colVisible: false,
        width: '100',
        editorType: "dxDateBox",
        colWidth: '15',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        nCol: '3',
      },
      {
        allowFiltering: true,
        type: 'campoData', dataType: 'date',
        dataField: 'dataDocumentoInterno', caption: 'Data doc.Interno ',
        colVisible: true, format: "dd/MM/yyyy", editorType: "dxDateBox", colWidth: '120', orderGriglia: 5, showClearButton: false,
        width: '125', class: 'data-doc-interno',
        colAlignment: 'center',
        nCol: '4', labelWidth: 157,
      },
      {
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.doc.Interno',
        colVisible: true, maxLength: '10', colWidth: '102', orderGriglia: 4, width: '38', nCol: '3', labelWidth: 132,
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },

      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Cliente**/


      {
        type: 'campoSpecial', dataField: "cliente_Descrizione", dataType: "", caption: "Cliente",
        colVisible: false,
        disableOnUpdate: true,
        disabled: true,
        colSpan: '4',
        nCol: '10',
        odataType: 'select',
        odataFilter: 'contains',//!-------------
        staticDataField: 'cliente_Descrizione',
        labelWidth: 90,
        width: '100',
        editorClass: 'cliente-desc',

        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },

      {
        type: 'campoSpecial', dataField: "contratto_Descrizione", dataType: "", caption: "Contratto",
        colVisible: false,
        disabled: true,
        disableOnUpdate: true,
        editorClass: 'cliente-desc',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idContratto',
        width: '100',
        nCol: '5',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'CerComponent',

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Contratto',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      {
        type: 'campoSpecial', dataField: "addebito_Descrizione", dataType: "",
        caption: "Addebiti",
        colVisible: false,
        disableOnUpdate: true,
        class: 'label-soggetti',
        odataType: 'select',
        odataFilter: 'contains',//!-------------
        staticDataField: 'addebito_Descrizione',
        width: '30',
        labelWidth: 56,
        disabled: true,
        nCol: '5',
        dynamic: {
          dataSource: "Sede",
          service: 'sede',
          autocomplete: true,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Addebiti',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '4' },
      /**Produttore**/
      // {
      //   type:'campoHidden',
      //   dataField:'idProduttore',
      //   caption:'',
      //   colVisible:false,
      //   visible:false,
      //   class:'d-none'
      // },

      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Soggetto", dataType: "", caption: "Prod./Detent.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        class: 'disabled-soggetti',
        placeHolder: '',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'produttore_Id_Soggetto',
        validation: [
          { type: 'required', message: 'Produttore obbligatorio' }
        ],
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?NostreAziende=N&TipoAttivita=P',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|produttore_Id_Soggetto', 'nsAzienda|aziendaProduttore', 'descrizione|produttore_Descrizione_Sede', 'id|idProduttore', 'numeroIscrizioneAlbo|autorizzazioneProduttore_Numero'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isProduttore eq true)',

          }

        }
      },
      {
        type: 'campo',
        colVisible: false,
        dataField: "aziendaProduttore",
        visible: false,
        caption: "",
        disableOnUpdate: false,
      },
      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Sede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: 'custom-47',
        labelWidth: 55,
        class: 'disabled-soggetti',
        /*  placeHolder: 'Digita la ragione sociale o il nome dell\'unità locale di produzione', */
        validation: [
          { type: 'required', message: 'Produttore UL obbligatorio' }
        ],
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idProduttore',
        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali di produzione",
          costantValue: [{
            key: 'produttore_Id_Soggetto',
            value: 'produttore_Id_Soggetto'

          }],
          queryString: '/$produttore_Id_Soggetto?$filter=(isProduttore eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idProduttore', 'numeroIscrizioneAlbo|autorizzazioneProduttore_Numero'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoProduttori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'addElencoProduttori',
          location: 'after',
          disabled: true,
          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei produttori e microraccolta",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '' },


      /***Autorizzazione Produttore ***/


      {
        type: 'campoSpecial', dataField: "autorizzazioneProduttore_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        nCol: '3',
        width: '100',
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idAutorizzazioneProduttore',
        /*  placeHolder: 'Digita in numero dell\'autorizzazione', */
        disableOnUpdate: true,
        dynamic: {
          queryString: "/$idProduttore",
          filterStatic: "",
          displayExpr: 'numero',
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttore'],
          },

          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneProduttore', 'numeroIscrizioneAlbo|produttoreNumeroIscrizioneAlbo', '|autorizzazioneProduttoreArea_Descrizione'],
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista delle autorizzazioni',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,
            isOdata: false,
            colonne: campiRicercaAutorizzazioneSoggetti,
            toolbarButtonsTopRight: [25]
          })
        }
      },
      {
        type: 'campoSpecial', dataField: "autorizzazioneProduttoreArea_Descrizione",
        dataType: "",
        caption: "Area",
        colVisible: false,
        nCol: '2',
        width: '100',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idAutorizzazioneProduttoreArea',
        /*  placeHolder: 'Digita in numero dell\'autorizzazione', */
        disableOnUpdate: true,
        showClearButton: true,
        dynamic: {
          queryString: "?idAutorizzazione=$idAutorizzazioneProduttore",

          displayExpr: 'descrizioneArea',
          dataSource: "AutorizzazioneArea",
          service: "autorizzazionearea",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttoreArea'],
          },
          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneProduttoreArea'],
          costantValue: [
            {
              key: 'idAutorizzazioneProduttore',
              value: 'idAutorizzazioneProduttore'
            }],

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista delle aree autorizzate',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,

            colonne: [
              {
                type: 'campo',
                dataField: "descrizioneArea",
                caption: 'Area',
                dataType: "text",
                colWidth: '100',
                colVisible: true,
              },


            ],
            isOdata: false
          })
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "produttoreAlboCategoria_Descrizione_Full",
        width: '100',
        caption: "N.Albo",
        disableOnUpdate: true,
        class: 'label-soggetti',
        nCol: '35',
        labelWidth: 55,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'idProduttoreAlboCategoria',
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'idProduttore', value: 'idProduttore' }],
          valueExpr: '',
          queryString: '/$idProduttore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          componentType: 'dynamicGrid',
          related: ['id|idProduttoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreProd', 'idCategoriaAlboGestore|idCategoriaAlboGestoreP'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona lista iscrizione all'albo`,
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridSimple,
              toolbarButtonsTopRight: [25],
              width: 1000,
              isOdata: false,
              colonne: colonneAlboCategoria
            }),

        }

      },

      {
        type: 'campo',
        caption: 'Tipo',
        labelVisible: true,
        labelColon: false,
        colVisible: false,
        editorType: 'selectBox',
        dataField: 'isDetentore',  // Con antonio il giorno 04/06 abbimo fatto questa modifica per poter far apparire la crocetta nel campo del formulario'tipoProduttore',
        dataType: '',
        nCol: 15,
        // odataType: 'select',
        // odataFilter: '=',//!-------------
        // staticDataField: 'isDetentore',
        lista: {
          dataSource: '',
          static: true,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showDropDownButton: true,
          items: [

            { id: false, descrizione: 'Nuovo Prod.' },
            { id: false, descrizione: 'Prod.' },
            { id: true, descrizione: 'Det.' },
          ]
        }
      },

      /***FIne Autorizzazione Produttore ***/

      /***Cantiere / Magazziono Produttore ***/

      {
        type: 'campoSpecial', dataField: "cantiere_Descrizione", dataType: "", caption: "Cantiere",
        width: '100',
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        editorClass: 'text-uppercase',
        class: '',
        nCol: '5',
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idCantiereFuoriUl',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idProduttore?$filter=(isSospeso ne true)",
          displayExpr: 'descrizione',
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Cantieri fuori unità locale",
          related: ['id|idCantiereFuoriUl'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona la lista dei fuori unità locale',
            name: 'CantiereFuoriUl',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 1000,
            colonne: colonneSede
          }),

        }
      },
      {
        type: 'campoSpecial', dataField: "magazzinoProduttore_Descrizione", dataType: "", caption: "Magaz",
        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        width: '100',
        nCol: '5',
        labelWidth: 55,
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idMagazzinoProduttore',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          related: ['id|idMagazzinoProduttore'],
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Magazzini produttore",
          queryString: '?idSede=$idProduttore',
          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleaziona la lista dei magazzini del soggetto',
            name: 'magazzinoProduttore',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 800,
            colonne: [
              {
                type: 'campo',
                dataField: "descrizione",
                caption: 'Magazzino',
                dataType: "text",
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false
          }),
        }
      },
      {
        type: 'campoHidden', colVisible: false, dataField: "caricoAutomatico_IdMagazzino",
        colSpan: '4',
        class: 'd-none',
        caption: "",


      },
      /***Fine Cantiere / Magazziono Produttore  ***/

      { type: 'empty', dataField: '', caption: ' ', colSpan: '4' },

      /***Trasportatore ***/
      {
        type: 'campoDesc', dataField: 'trasportoDesc', defaultValue: 'Nessun trasporto', colSpan: '4',
        labelVisible: false, nCol: '10'
      },

      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Soggetto", dataType: "", caption: "Trasportatore",
        nCol: '5',
        colVisible: false,
        labelVisible: true,
        editorClass: 'trasportatore-desc',
        class: 'disabled-soggetti',
        width: '100',
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'contains',
        staticDataField: 'trasportatore_Id_Soggetto',
        dynamic: {
          autocomplete: false,
          dataSource: "Soggetto",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Sedi legali trasportatori",
          queryString: '?NostreAziende=N&TipoAttivita=T',

          componentType: 'dynamicGrid',
          //
          related: ['idSoggetto|trasportatore_Id_Soggetto', 'descrizione|trasportatore_Descrizione_Sede', 'id|idTrasportatore', 'numeroIscrizioneAlbo|trasportatore_NumDataIscrizioneAlbo'],
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Trasportatore',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,
            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isTrasportatore eq true)',

          }
        }

      },
      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Sede", dataType: "", caption: "U.L.",
        colVisible: false,
        labelVisible: true,
        editorClass: 'trasportatore-desc',
        class: 'disabled-soggetti',
        width: '100',
        labelWidth: 55,
        nCol: 'custom-47',
        disableOnUpdate: true,
        showClearButton: true,
        // odataType: 'select',
        // odataFilter: 'contains',
        // staticDataField: 'trasportatore_Descrizione_Sede',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'ragioneSociale',
          caption: `Selezione unità locale`,
          componentType: 'dynamicGrid',
          related: ['id|idTrasportatore', 'descrizione|trasportatore_Descrizione_Sede', 'numeroIscrizioneAlbo|trasportatore_NumDataIscrizioneAlbo'],
          costantValue: [{
            key: 'trasportatore_Id_Soggetto',
            value: 'trasportatore_Id_Soggetto'

          }],
          queryString: '/$trasportatore_Id_Soggetto?$filter=(isTrasportatore eq true)',
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),

        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoVettori",
        dataType: "",
        nCol: 'auto',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: '',
        button: {
          text: '',
          name: 'addElencoVettori',
          location: 'after',
          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei vettori 2",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatore",
        class: 'd-none',
        caption: "Trasportatore",
        disableOnUpdate: false,
        editorType: '',
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idTrasportatore',
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Sede',
          autocomplete: false

        }

      },
      /***FIne Trasportatore ***/

      /**Albo e Categoria Albo Trasportatore**/



      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneTrasportatoreAlbo_Full",
        width: '100',
        caption: "N.Albo",
        disableOnUpdate: true,
        showClearButton: true,
        nCol: '5',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idTrasportatoreAlboCategoria',
        dynamic: {
          valueExpr: '',
          queryString: '/$idTrasportatore',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          caption: "Lista categoria albo del trasportatore selezionato",
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',

          related: ['id|idTrasportatoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreTras', 'idCategoriaAlboGestore|idCategoriaAlboGestoreT'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona la lista dell'iscrizione albo`,
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              isOdata: false
            }),
        }

      },
      /**Automezzi */
      {
        type: 'campoSpecial', colVisible: false, dataField: "automezzo_Targa",
        caption: "Motrice",
        width: '100',
        labelWidth: 54,
        disableOnUpdate: true,
        nCol: '25',
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idAutomezzo',
        dynamic: {
          valueExpr: '',
          queryString: "/$idTrasportatore?$filter=( tipoautomezzo ne 'D' )",
          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: false,
          caption: 'Lista motrici',
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Automezzo',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            toolbarButtonsTopRight: [25],
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),
        }

      },
      {
        type: 'campoSpecial', dataField: "rimorchio_Targa", dataType: "", caption: "Rimorchio",
        width: '100',
        nCol: '25',
        colVisible: false,
        labelVisible: true,
        labelWidth: 54,
        class: 'rimorchio',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idRimorchio',
        showClearButton: true,
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'Automezzo',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'targa',
          service: 'automezzo',
          caption: "Lista Automezzi",
          queryString: "/$idTrasportatore?$filter=( tipoautomezzo in ('D','E','F') )",
          related: ['id|idRimorchio'],
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'rimorchio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Rimorchio Automezzo',
            name: 'Rimorchio',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            toolbarButtonsTopRight: [25],
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),

        }
      },
      { type: 'empty', dataField: '', },


      /**Autista***/

      {
        type: 'campoSpecial', dataField: "autista_Cognome_Nome", dataType: "", caption: "Autista",
        width: '100',
        colVisible: false,
        nCol: '5',
        labelVisible: true,
        maxLength: "50",
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idAutista',
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'Autista',
          service: 'autista',
          autocomplete: false,
          searchExpr: {
            fatherDataField: 'trasportatore_Descrizione_Full',

            //expand: 'Sede',
            //headerField: 'RagioneSociale',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idAutista'],
            optionalFilters: {
              isAutista: true,
              //NsAzienda: true
            },
          },
          valueExpr: '',
          displayExpr: ['nome', 'cognome'],
          caption: "Lista Autisti",
          queryString: '/$idTrasportatore?$filter=(isautista eq true)',
          filterStatic: '',
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          related: ['id|idAutista'],
          buttonOption: {
            text: 'Autista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Autista',
            name: 'Autista',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,

            colonne: colonneAutista
          }),

        }
      },

      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_1",
        colVisible: false,
        dataType: "",
        caption: "Oper.1",
        colWidth: '100',
        nCol: '25',
        width: '200',
        labelWidth: 54,
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idOperatore1',
        dynamic: {
          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore1'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore1'],
          autocomplete: false,
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Operatore',
            name: 'Operatori',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,

            colonne: colonneAutista
          }),

        }
      },

      {
        type: 'campoSpecial',
        dataField: "descrizione_Operatore_2",
        colVisible: false,
        dataType: "",
        caption: "Oper.2",
        colWidth: '100',
        width: '100',
        nCol: '25',
        labelWidth: 54,
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idOperatore2',
        dynamic: {

          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isoperaio eq true)',
          searchExpr: {
            fatherDataField: '',
            valueExpr: 'id',
            dataFields: ['nome', 'cognome'],
            related: ['id|idOperatore2'],
            optionalFilters: {
              isOperatore: true,

            },
          },
          displayExpr: 'cognome',
          dataSource: 'Autista',
          service: 'autista',
          related: ['id|idOperatore2'],
          autocomplete: false,
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'
          }],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Operatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Operatore',
            name: 'Operatori',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,

            colonne: colonneAutista
          }),
        }
      },
      { type: 'empty', dataField: '', },


      /* {type: 'campoDesc', dataField: 'carrozzeriemobiliautomezzo', labelVisible: false, nCol: '6',},
      { type: 'campoDesc', dataField: 'carrozzerieMobiliRimorchio', labelVisible: false, nCol: '6', },
       */


      { type: 'empty', caption: ' ', colSpan: '4', dataField: '', dataType: '' },

      /**Destinatario**/
      {
        type: 'campo', colVisible: false, dataField: "idDestinatario",
        editorType: '',
        class: 'd-none',
        colSpan: '4',
        caption: "Destinatario",
        disableOnUpdate: true,

        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idDestinatario',
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Soggetto", dataType: "", caption: "Destinatario",
        nCol: '5',
        width: '100',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'destinatario_Id_Soggetto',
        validation: [{ type: 'required', message: 'Destinatario obbligatorio' }],
        disableOnUpdate: true,
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Smaltitori/Destinatari",
          queryString: '?NostreAziende=N&TipoAttivita=S',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|destinatario_Id_Soggetto', 'nsAzienda|aziendaDestinatario', 'descrizione|destinatario_Descrizione_Sede', 'id|idDestinatario'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Destinatario',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=((isDestinatario eq true) or (isSmaltitore eq true))',

          }

        }
      },
      {
        type: 'campo',
        colVisible: false,
        dataField: "aziendaDestinatario",
        visible: false,
        caption: "",
        disableOnUpdate: false,
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Sede", dataType: "", caption: "U.L",
        nCol: '5',
        width: '100',
        colVisible: false,
        labelVisible: true,
        labelWidth: 55,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        validation: [{ type: 'required', message: 'Destinatario obbligatorio' }],
        disableOnUpdate: true,
        showClearButton: true,

        // odataFilter: 'contains',
        // staticDataField: 'destinatario_Descrizione_Sede',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'sede',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Smaltitori/Destinatari",
          componentType: 'dynamicGrid',
          related: ['id|idDestinatario', 'nsAzienda'],
          costantValue: [{
            key: 'destinatario_Id_Soggetto',
            value: 'destinatario_Id_Soggetto'

          }],
          queryString: '/$destinatario_Id_Soggetto?$filter=((isDestinatario eq true) or (isSmaltitore eq true))',


          buttonOption: {
            text: 'UL dest',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Destinatario',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatario_Descrizione_Full",
        dataType: "",
        caption: "Autorizz",
        colVisible: false,
        width: '100',
        nCol: '5',
        disableOnUpdate: true,
        showClearButton: true,
        /* placeHolder: 'Digita il Numero dell\'autorizzazione', */
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idAutorizzazioneDestinatario',
        dynamic: {
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idDestinatario",
          filterStatic: "",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneDestinatario'],


          },

          dataSource: "Autorizzazione",
          service: 'autorizzazione',
          displayExpr: 'numero',
          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneDestinatario'],
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista delle autorizzazioni',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneSoggetti,
              isOdata: false
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        type: 'campoSpecial', dataField: "magazzinoDestinatario_Descrizione", dataType: "", caption: "Magaz.",
        width: '100',
        nCol: '5',
        labelWidth: 55,
        colVisible: false,
        labelVisible: true,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        odataType: 'integer',
        odataFilter: '=', showClearButton: true,

        staticDataField: 'idMagazzinoDestinatario',
        dynamic: {

          queryString: "?idSede=$idDestinatario",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Magazzini unità locale",

          related: ['id|idMagazzinoDestinatario'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],


          },

          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista magazzino del soggetto selezionato',
            name: 'magazzinoDestinatario',
            location: 'after',

          },
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Magazzino',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },
      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatarioArea_Full", dataType: "", caption: "Area",
        nCol: '3',
        width: '100',

        colVisible: false,
        labelVisible: true,
        class: 'label-soggetti',
        /*  placeHolder: 'Digita il nome dell\'area autorizzata', */
        disableOnUpdate: true,
        odataType: 'integer',
        odataFilter: '=', showClearButton: true,

        staticDataField: 'idAutorizzazioneDestinatarioArea',
        dynamic: {
          costantValue: [{ key: 'idAutorizzazioneDestinatario', value: 'idAutorizzazioneDestinatario' }],
          componentType: 'dynamicGrid',
          queryString: '?idAutorizzazione=$idAutorizzazioneDestinatario',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          service: 'autorizzazionearea',
          autocomplete: false,
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneArea,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idAutorizzazioneDestinatarioArea'],
          },
          valueExpr: '',
          caption: "Lista delle aree autorizzate",
          related: ['id|idAutorizzazioneDestinatarioArea'],
          buttonOption: {
            text: 'AutorizzazioneArea',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista delle aree autorizzate',
            name: 'AutorizzazioneArea',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneArea,
              isOdata: false
            }),


        }
      },

      {
        type: 'campoSpecial', dataField: 'idOperazioneRD', dataType: '',
        colCaption: 'Op.',
        caption: 'Op. Smalt/Rec.',
        colVisible: true,
        width: '50',
        nCol: '2',
        colSpan: 4,
        orderGriglia: 10,
        colWidth: 50,
        editorClass: 'text-uppercase',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idOperazioneRD', showClearButton: true,

        validation: [
          { type: 'required', message: 'Op.smaltim./recup. obbligatoria' }
        ],
        disableOnUpdate: true,
        customTooltip: {
          typeContent: 'dynamicContent',
          content: '',
          dynamicContent: '$descrizione'
        },
        dynamic: {
          displayExpr: '',
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          caption: "Lista Modalità di smaltimento",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'OperazioneRD',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: "Seleziona elenco delle operazioni di smaltimento",
            name: 'OperazioneRD',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },




      { type: 'empty', colSpan: '4', dataField: '', dataType: '', caption: ' ' },

      /**Intermediario**/



      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Soggetto", dataType: "", caption: "Intermediario",
        width: '100',
        nCol: '5',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'intermediario_Id_Soggetto',
        dynamic: {
          autocomplete: false,
          dataSource: "Soggetto",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Intermediario",
          queryString: '?NostreAziende=N&TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|intermediario_Id_Soggetto', 'descrizione|intermediario_Descrizione_Sede', 'id|idIntermediario', 'numeroIscrizioneAlbo|iscrizioneAlboIntermediarioAlbo'],

          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Intermediario ',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto,
            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',

          }
        }

      },
      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Sede", dataType: "", caption: "U.L",
        width: '100',
        nCol: 'custom-47',
        colVisible: false,
        labelVisible: true,
        labelWidth: 55,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        disableOnUpdate: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idIntermediario',
        dynamic: {
          autocomplete: false,
          dataSource: "sede",
          service: 'sede',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Intermediario",
          costantValue: [{
            key: 'intermediario_Id_Soggetto',
            value: 'intermediario_Id_Soggetto'

          }],
          queryString: '/$intermediario_Id_Soggetto?$filter=(isIntermediario eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idIntermediario', 'numeroIscrizioneAlbo|iscrizioneAlboIntermediarioAlbo'],
          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),
          /*detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',
          }*/
        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoIntermediari",
        dataType: "",
        nCol: '',
        caption: "addElencoVettori",
        editorClass: 'nica-plaintext-readonly',
        class: '',
        button: {
          text: '',
          name: 'addElencoIntermediari',
          location: 'after',

          event: "addDati",
          hint: "Mostra e gestisci l'elenco dei vettori 3",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: '', dataType: '' },


      /***Intermediario Albo ***/


      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneIntermediarioAlbo_Full",
        width: '100',
        caption: "N.Albo",
        colSpan: '4',
        nCol: '5',
        disableOnUpdate: true,
        showClearButton: true,
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'idIntermediarioAlboCategoria',
        dynamic: {
          costantValue: [
            {
              key: 'idIntermediario',
              value: 'idIntermediario'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'intermediario_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'intermediario_Descrizione_Sede'
            }

          ],
          valueExpr: '',
          queryString: '/$idIntermediario',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,
          caption: "Lista categoria albo del intermediario selezionato",
          componentType: 'dynamicGrid', // prima 'AnaAlboComponent',
          related: ['id|idIntermediarioAlboCategoria', 'dataInizio|dataIscrizioneAlboI', 'idCategoriaAlboGestore|idCategoriaAlboGestoreI'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: `Seleziona la lista dell'iscrizione albo`,
            name: 'albo',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,
            isOdata: false,
            width: 1000,
            //toolbarButtonsTopRight:[25],
            colonne: colonneAlboCategoria,
          })
        }

      },


    ]
  },



  {
    itemType: "group", captionClass: 'no-line-caption-bottom', colGroup: 45, caption: "", colCount: "5", class: 'dati-rifiuto ', groupDataField: 'dati-generali-movimento', data: [

      {
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '100',
        colAlignment: 'center',
        orderGriglia: 7,
        nCol: 4,
        width: '100',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        showClearButton: true,
        odataType: 'string',
        odataFilter: '=',
        staticDataField: 'eer',
        dynamic: {
          autocomplete: true,
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'cer',
          service: 'cer',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['pericoloso|isCerPericoloso', 'descrizione|eeR_Descrizione'],

          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione elenco dei rifiuti EER',
            name: 'eer',
            location: 'after',
          },
          settingGrid: gridSimple,
          buttons: [
            {

              class: 'badge',
              name: 'addSchedaTecnica',
              accesskey: 's',
              location: 'after',
              event: "SchedarifiutiComponent",
              text: '',
              hint: "Incolla dati dalla scheda descrittiva rifiuti",
              icon: "glyphicon icon-elenco-cer-trasp",
              outPutValue: false,
              visible: true
            },
            {
              name: 'GiacenzeRifiuti',
              icon: 'glyphicon icon-giacenze-magazzino',
              hint: 'Giacenze Rifiuti',
              location: 'after',
              event: 'StatisticarifiutiComponent',
              visible: true


            },
          ]
        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],


      },
      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.",
        /*  width: 4.3 + 'vw', */
        colWidth: '65',
        colVisible: true,
        labelVisible: true,
        nCol: '2',
        maxLength: '10',
        class: 'rif-cer',
        editorClass: 'text-uppercase',
        orderGriglia: 8,
        odataType: 'string',
        odataFilter: 'contains',
        staticDataField: 'riferimentoEER',
      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "number", caption: "SF",
        width: '100',
        colWidth: '40',
        colVisible: true,
        labelVisible: true,
        nCol: 15,
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        customTooltip: {
          typeContent: 'dynamicContent',
          content: '',
          dynamicContent: '$descrizione'
        },
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idStatoFisico',
        maxLength: '1',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Stato Fisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric

        },
      },
      {
        type: 'campo', dataField: "isUrbano", dataType: "", caption: "Urbano",
        nCol: '15',
        colVisible: false,
        labelVisible: true,
        editorType: 'dxCheckBox',
        class: 'cer-urbano',
        defaultValue: false,
        odataType: 'boolean',
        odataFilter: '=',
        staticDataField: 'isUrbano',
      },

      {
        type: 'campoSpecial', dataField: "lotto_Descrizione", caption: "Lotto di prod.",
        colVisible: false,
        labelVisible: true,
        width: '100',
        nCol: '3',
        disabled: true,
        showClearButton: true,
        disableOnUpdate: true,
        odataType: 'select',
        dynamic: {
          valueExpr: '',
          displayExpr: 'descrizione',
          queryString: '/$idProduttore',
          costantValue: [
            { key: 'idProduttore', value: 'idProduttore' },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }
          ],
          dataSource: 'lotto',
          service: 'lotto',
          autocomplete: false,
          caption: "Lista Lotti",
          componentType: 'dynamicGrid',
          related: ['id|idLotto'],
          buttonOption: {
            text: 'lotto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista lotti di produzione',
            name: 'LottoProduzione',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
              {
                colVisible: true,
                type: 'campoData',
                dataField: "dataInizio",
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                dataType: "date",
                caption: "Data Inizio",
              },

              {
                colVisible: true,
                type: 'campoData',
                dataField: "dataFine",
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                dataType: "date",
                caption: "Data Fine",
              },
            ]
          }),
        },
      },

      {
        type: 'campo',
        dataField: "eeR_Descrizione",
        caption: "Descr. EER",
        dataType: "",
        nCol: '10',
        colVisible: false,
        colSpan: '5',
        maxLength: '255',
        disableOnUpdate: true,
        disabled: true,
        class: 'opacity-100'
      },

      {
        type: 'campoSpecial',
        dataField: "listaHP", caption: "Carat.Peric.",
        colVisible: true,
        orderGriglia: 12,
        colSpan: '5',
        width: '100',
        nCol: '10',
        hideOnEdit: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'Hp',
          service: 'generic',
          autocomplete: false,
          displayExpr: '',
          valueExpr: 'id',
          caption: "Lista Caratteristiche di Pericolo",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Caratteristiche Pericolo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona lista caratteristiche pericolo',
            name: 'stoccaggio',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridMultiple,
            colonne: generic
          }),

        }
      },

      {
        type: 'campo',
        dataField: "caratteristicheChimiche",
        caption: "Carat.chim/fis.",
        dataType: "",
        width: '100',
        maxLength: '255',
        nCol: '9',
        colVisible: false,
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addDatiRifiuto",
        dataType: "",
        caption: "addDatiRifiuto",
        nCol: '2',
        editorClass: 'nica-plaintext-readonly',
        class: '',
        width: 100,
        button: {
          text: 'Altri dati relat.rifiuto',
          name: 'addDatiRifiuto',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati relativi al rifiuto",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,


        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campo',
        dataField: "annotazioni",
        caption: "Annotazioni",
        dataType: "",
        colSpan: '5',
        nCol: '10',
        colVisible: false,
        maxLength: '255',

      },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },

      {
        type: 'campo', dataField: "quantitaOrigineKg", dataType: "", caption: "Peso partenza",
        format: environment.PRECISION,
        maxLength: "11",
        hideOnEdit: false,
        colVisible: false,
        labelVisible: true,
        editorType: 'dxNumberBox',
        disabled: true,
        readonly: true,
        nCol: '3'


      },
      {
        type: 'campo', dataField: "verificatoPartenza", dataType: "boolean", caption: "Verificato in partenza",

        colVisible: false,
        labelVisible: true,
        labelColon: false,
        labelPosition: 'right',
        hideOnEdit: false,
        labelWidth: 138,
        editorType: 'dxCheckBox',
        disabled: true,
        readonly: true,
        nCol: '3'
      },

      {
        type: 'campo', dataField: "volume", dataType: "", caption: "Volume ",
        format: '########0.###',
        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        editorType: 'dxNumberBox',
        nCol: '3',
        width: 53
      },
      {
        type: 'campoSpecial', dataField: "unitaMisuraVolume", dataType: "", caption: "MC/LT",
        colVisible: false,
        orderGriglia: 9,
        labelVisible: true,
        width: '100',
        class: 'volumeUm',
        maxLength: '1',
        nCol: '2',
        editorType: 'dxSelectBox',
        disabled: true,
        lista: {
          dataSource: 'umVolume',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          placeholder: ' ',
          widthOnOpened: '31px',
          showClearButton: false,
          isDefaultOption: false,
          showDropDownButton: false,
          static: true,
        }
      },
      { type: 'empty', dataField: "", dataType: "", caption: "", nCol: '1' },

      {
        type: 'campoSpecial', colVisible: false, dataField: "adr",
        caption: "ADR",
        disabled: true,
        readonly: true,
        width: '100',
        nCol: '3',
        editorType: 'dxSelectBox',

        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          showDropDownButton: true,
          placeholder: 'Si/No',
          static: true,

        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "testoADR_Descrizione",
        width: '100',
        caption: "Testo ADR",
        class: 'testo-adr',
        disabled: true,
        disableOnUpdate: true,
        nCol: '6',
        dynamic: {
          costantValue: [
            { key: 'eer', value: 'eer' }
          ],
          valueExpr: '',

          autocomplete: false,
          displayExpr: 'descrizione',
          dataSource: 'TestiAdr',
          related: ['id|idTestoADR', 'idClasseAdr', 'idOnu|idONU'],

          service: 'testoAdr',
          caption: "Lista Testi ADR",
          componentType: 'TestiAdrComponent',//'dynamicGrid',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },

        }

      },
      {
        type: 'campo',
        visible: false,
        colVisible: false,
        class: 'd-none',
        dataField: 'classeAdr_Descrizione'
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idClasseAdr",
        width: '100',
        maxLength: '6',
        caption: "Classe",
        class: 'classe-adr',
        showClearButton: false,
        disabled: true,
        disableOnUpdate: true,
        nCol: '2',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'Adr',
          service: 'generic',
          autocomplete: false,
          related: ['descrizione|classeAdr_Descrizione'],
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista Classi ADR",
          componentType: 'dynamicGrid',
          settingGrid: {
            ...settingGridGeneric
          },

          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          }
        },
        customTooltip: {
          typeContent: 'dynamicContent',
          content: '',
          dynamicContent: '$descrizione'
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idONU",
        width: '100',
        nCol: '2',
        maxLength: '6',
        caption: "Onu",
        showClearButton: false,
        disabled: true,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'onu',
          service: 'generic',
          autocomplete: false,
          caption: "Lista ONU",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: {
            ...settingGridGeneric,
            isOdata: true
          },
        },
        customTooltip: {
          typeContent: 'dynamicContent',
          content: '',
          dynamicContent: '$descrizione'
        }

      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },

      {
        type: 'campoData',
        dataField: "dataInizioTrasporto",
        caption: "Data iniz.trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        nCol: '3',
        maxLength: '15',
        width: '50',
        odataType: 'date',
        odataFilter: '>=',
        staticDataField: 'dataInizioTrasporto',
        showClearButton: false,
        colVisible: false,
        // calendarOptions: {min: new Date()} ,
      },
      {
        type: 'campoData',
        dataType: 'time',
        dataField: 'oraInizioTrasporto',
        caption: 'Ora inizio',
        disableOnUpdate: true,
        nCol: '2',
        colVisible: false,
        editorType: "dxDateBox",
        disabled: true,
        readonly: true,
        colWidth: '15',
        width: '100',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
      },
      {
        type: 'campoData',
        dataField: "dataFineTrasporto",
        caption: "Data fine trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        disabled: true,
        readonly: true,
        maxLength: '15',
        nCol: '3',
        width: '50',
        odataType: 'date',
        odataFilter: '<=',
        staticDataField: 'dataFineTrasporto',
        calendarOptions: { min: new Date() },
        colVisible: false,
        showClearButton: false,
        disableOnUpdate: true,
      },
      {
        type: 'campoData', dataType: 'time',
        dataField: 'oraFineTrasporto',
        caption: 'Ora fine',
        class: 'ora-fine',
        disabled: true,
        readonly: true,

        nCol: '2',
        colVisible: false,
        editorType: "dxDateBox",
        colWidth: '15',
        width: '100',
        format: 'HH:mm',
        mask: 'HH:mm',
        showClearButton: false,
        disableOnUpdate: true,
      },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo',
        dataField: 'numeroColli',
        class: 'quantita-origine',
        width: '100',
        caption: 'N.Colli',
        maxLength: '10',
        editorType: 'dxNumberBox',
        format: '0######',
        disabled: true,
        colVisible: false,
        readonly: true,
        nCol: '3',
      },
      {
        type: 'campo',
        class: 'ps-1',
        dataType: 'boolean',
        dataField: 'rinfusa',
        caption: 'Rinfusa',
        editorType: 'dxCheckBox',
        colVisible: false,
        nCol: '2',
      },
      {
        type: 'campoSpecial',
        dataField: 'imballo_Descrizione',
        caption: 'Imballo',
        class: 'imballo',
        width: '100',
        colVisible: false,
        maxLength: '10',
        nCol: '6',
        showClearButton: true,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          autocomplete: false,
          displayExpr: 'descrizione',
          dataSource: 'Imballo',
          related: ['id|idImballo'],
          queryString: '',
          service: 'imballo',
          caption: "Lista Imballi",
          componentType: 'ImballiComponent',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Imballaggi',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            mode: 'row',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            height: 500,
            showColBlank: false,



          }
        }

      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "altriDatiFormulario",
        dataType: "",
        class: '',
        caption: "altriDatiFormulario",
        nCol: '2',

        button: {
          text: 'Altri dati formulario',
          name: 'addDatiFormulario',
          location: 'after',
          event: "addDati",
          hint: "Specifica altri dati formulario",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },

      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', caption: ' ', dataField: '', dataType: '', colSpan: '5' },

      {
        type: 'campoSpecial',
        dataType: '',
        dataField: 'tipoAccettazione',
        caption: 'Accettazione',
        colVisible: false,
        disabled: true,
        readonly: true,
        width: '100',
        nCol: '3',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'accettazioneTipo',
          valueExpr: 'id',
          displayExpr: 'id',
          listadisplayExpr: 'descrizione',
          width: '150px',
          isDefaultOption: false,
          static: true,
          showDropDownButton: true,
          placeholder: ' ',

        },
        customTooltip: {
          typeContent: 'listaContent',
          content: '',
          dynamicContent: '$descrizione'
        },

      },
      {
        type: 'campoSpecial', dataField: "idMotivoRespinta", dataType: "", caption: "Motivo resping.",
        labelVisible: true,
        width: '100',
        nCol: '6',
        editorType: 'dxSelectBox',
        disabled: true,
        colVisible: false,
        lista: {
          dataSource: 'MotivazioniRespingimento',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          showClearButton: false,
          placeholder: '',
          showDropDownButton: false,
        }

      },
      {
        type: 'campo', dataField: "descrizioneRespinta", dataType: "", caption: " ",
        disabled: true,
        colVisible: false,
        labelVisible: false,
        class: 'autoLabelWidth',
        placeHolder: 'Specifica il motivo',
        width: '100',
        nCol: '6',

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo', dataField: "quantitaKg", dataType: "number", caption: "Peso netto Kg",
        format: environment.PRECISION,
        colAlignment: 'right',
        colCaption: 'Peso',
        width: '100',
        orderGriglia: 11,
        nCol: '3',
        maxLength: "8",
        colVisible: true,
        colWidth: '112',
        labelVisible: true,
        // editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        odataType: 'integer',
        odataFilter: '=',
        staticDataField: 'quantitaKg',
        // validation: [
        //   { type: 'required', message: 'Peso obbligatorio' }
        // ]
      },
      {
        type: 'campo', dataField: "quantitaRespinta", dataType: "", caption: "Peso Resp.Kg",
        width: '100',
        format: '',
        nCol: '3',

        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        class: 'peso-respinto',
        editorType: 'dxNumberBox',
      },
      { type: 'empty', dataField: '', dataType: '', nCol: '6' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campo', dataField: "scontrino", dataType: "", caption: "N.Scontrino",
        width: '100',
        maxLength: "10",
        colVisible: false,
        colWidth: '100',
        nCol: '3',
        labelVisible: true,
        odataType: 'string',
        odataFilter: 'contains',
        staticDataField: 'scontrino',
      },


      {
        type: 'simpleButton', colVisible: false,
        dataField: "datiPesata",
        dataType: "",
        caption: "datiPesata",
        class: 'dati-pesata',
        nCol: '9',
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: 'Altri dati pesata',
          name: 'addDatiPesata',
          location: 'after',
          event: "addDati",
          hint: "Dati relativi alla pesata",
          icon: "glyphicon mdi mdi-open-in-new",
          outPutValue: false,

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: "", dataType: "", caption: " ", colSpan: '5' },



      {
        type: 'campoSpecial', colVisible: false, dataField: "categoriaDocumento_Descrizione",

        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idCategoriaDocumento',

        labelVisible: true,
        caption: "Categoria doc.",
        disableOnUpdate: true,
        nCol: 5,
        showClearButton: true,
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Categorie documento",
          componentType: 'dynamicGrid',
          related: ['id|idCategoriaDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idTipoDocumento",
        class: 'd-none',
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idTipoDocumento',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'soggetti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          related: ['descrizione|tipoDocumento_Descrizione'],


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "tipoDocumento_Descrizione",
        nCol: 5,
        disableOnUpdate: true,
        caption: "Tipo doc.",
        class: 'tipo-doc',
        labelWidth: 77,
        showClearButton: true,
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idTipoDocumento',
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista tipo documento",
          componentType: 'dynamicGrid',
          related: ['id|idTipoDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Tipo',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },


      {
        type: 'campoSpecial', colVisible: false, dataField: "zonaDocumento_Descrizione",

        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idZonaDocumento',
        nCol: 5,
        caption: "Zona doc.",
        disableOnUpdate: true,
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista zona documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idZonaDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Zona',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idZonaDocumento",

        class: 'd-none',
        maxLength: '10',
        caption: "Zona doc.",
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idZonaDocumento',
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          componentType: 'grid',
          related: ['descrizione|zonaDocumento_Descrizione'],

        }

      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idBacino",
        class: 'd-none',

        dynamic: {

          dataSource: 'Zona',
          queryString: '?nomeTabella=movimenti',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista tipo documento",
          related: ['descrizione|bacinoDocumento_Descrizione'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "bacinoDocumento_Descrizione",
        odataType: 'select',
        odataFilter: '=',
        staticDataField: 'idBacinoDocumento',
        nCol: 5,
        caption: "Bacino Doc.",
        disableOnUpdate: true,
        showClearButton: true,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          dataSource: 'Bacino',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Bacini documento",
          queryString: '?nomeTabella=movimenti',
          componentType: 'dynamicGrid',
          related: ['id|idBacinoDocumento'],
          settingGrid: gridEditable,
          buttonOption: {
            text: 'bacino',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Bacino',
            name: 'categorie',
            location: 'after',
          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },

      { type: 'empty', dataField: '', dataType: '', colSpan: '5', caption: ' ' },

      {
        type: 'campoSpecial',
        dataField: "idCategoriaRaee",
        caption: "Cat.Raee",
        hideOnEdit: true,
        editorType: "dxSelectBox",
        dataType: "",
        visible: true,
        width: '15.5vw',

        colVisible: false,
        lista: {
          dataSource: 'Raee',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        }

      },

      {
        type: 'campo',
        dataField: "tipoRaee",
        caption: "P/D",
        hideOnEdit: true,
        dataType: "",
        editorClass: 'text-uppercase',
        class: 'tipo-raee',
        width: 2 + 'vw',
        colVisible: false,


      },

      {
        type: 'campoSpecial', dataField: 'operazioneVeicoliFuoriUso', dataType: '', caption: 'Attità Veicoli FU',
        editorType: 'dxSelectBox',
        hideOnEdit: true,
        colVisible: false,
        width: '9vw',

        class: 'veicoliFU',
        lista: {
          dataSource: 'operazioneVeicoliFuoriUso',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campoSpecial',
        dataField: "imballaggioRicevuto",
        caption: "Imballaggi",
        hideOnEdit: true,
        dataType: "",
        colVisible: false,
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: 'imballaggioRicevuto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }

      },
      {
        type: 'campoSpecial',
        dataField: "prodottoDaImballaggi",
        caption: "Prov.da imballaggi",
        editorType: 'dxRadioGroup',
        dataType: "",

        hideOnEdit: true,
        class: 'prodottoDaImballaggi',
        colVisible: false,

        radioGroup: {

          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,


        }
      },
      {
        type: 'campo',
        dataField: "isAlluminio",
        caption: "Alluminio",
        editorType: "dxCheckBox",
        dataType: "boolean",
        disableOnUpdate: true,
        colVisible: false,
        defaultValue: false,
        hideOnEdit: true,

      }, {
        type: 'campoGriglia', defaultValue: "", dataField: "movimentiRegistro", dataType: "", caption: "Movimenti Registro",

        nCol: 10,
        labelVisible: false,
        showInColumnChooser: false,
        formGrid: {
          service: 'grigliaMovimentiRegistro',
          api: 'MovimentoRifiutoRegistro/GetAllTemp',
          remoteOperation: true,
          queryString: '?idCausale=$idCausale&idPosizioneRifiuto=$idPosizioneRifiuto&idCantiereFuoriUL=$idCantiereFuoriUl&idProduttoreSede=$idProduttore',
          isEditable: false,
          isEditableNewRow: false,
          isEditableEditRow: false,
          isEditableDeleteRow: false,
          isOdata: false,
          showToolbarTop: false,
          showToolbarBottom: false,
          tableHeight: 70,
          tableWidth: 700,
          showFilter: false,
          selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
          idTable: 'movimentiRegistro',
          isSearchable: false,
          // queryStringInEditor: '/$idCampoDocumentoRifiuto',
          isKeyID: false,
          notTestQuery: true,


        }

      },
      { type: 'empty', dataField: '', dataType: '' },

      /**Campi Nascosti**/
      {
        type: 'campo', dataField: "id", dataType: "", caption: "Codice",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',

      },
      {
        type: 'campo', dataField: "causale_Id_Operazione", dataType: "", caption: "Operazione",
        colVisible: false,
        hideOnEdit: true,
        orderGriglia: 1,
        nCol: '10',
        colWidth: 90,
      },
      {
        type: 'campoSpecial',
        colVisible: false, dataField: "idAutorizzazioneDestinatario",
        caption: "Autorizz4",
        class: 'd-none',
        visible: false,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: '',

          displayExpr: 'id',
          dataSource: 'Autorizzazione?id=',
          autocomplete: false,

          caption: "Lista Autorizzazioni",
          componentType: 'grid',



        }

      },
      {
        /***Autorizzazione Area destinatario ***/
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneDestinatarioArea",
        class: 'd-none',
        visible: false,
        caption: "Autorizz.Area",
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizioneArea',
          dataSource: 'AutorizzazioneArea',
          autocomplete: false,
          related: ['descrizioneArea|autorizzazioneDestinatarioArea_Full'],
          caption: "Lista Autorizzazioni",
          componentType: 'grid',


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idMagazzinoDestinatario",
        hideOnEdit: false,
        class: 'd-none',
        visible: false,

        caption: "Magazzino.",
        dynamic: {
          costantValue: [{
            key: 'idSede',
            value: 'idDestinatario'
          }],
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'MagazzinoRifiuti',
          autocomplete: false,
          //related:['descrizione|magazzinoDestinatario_Descrizione']


        }

      },
      {
        type: 'campo', colVisible: false, dataField: "idIntermediario",
        editorType: '',
        class: 'd-none',
        visible: false,
        colSpan: '4',
        caption: "",
        disableOnUpdate: true,


      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idIntermediarioCategoriaAlbo",
        class: 'd-none',
        visible: false,
        colSpan: '4',
        dynamic: {
          valueExpr: '',
          displayExpr: 'id',
          dataSource: 'AlboCategoria',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idCantiereFuoriUl",
        class: 'd-none',
        visible: false,
        colSpan: '4',
        hideOnEdit: false,
        caption: "Cantiere",
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutista",
        colSpan: '4',
        labelVisible: false,
        class: 'd-none',
        visible: false,
        nCol: '0',
        caption: "idAutista",
        showClearButton: true,

        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'Autista?id=',

          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          related: ['nome,cognome,matricola|autista_Descrizione_Full'],

        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutomezzo",
        caption: "Automezzo",
        class: 'd-none',
        visible: false,
        colSpan: '4',
        dynamic: {

          valueExpr: '',
          queryString: 'id',
          dataSource: '',
          displayExpr: 'id',
          autocomplete: false,


        }

      },
      {
        type: 'campoSpecial', dataField: "idRimorchio", dataType: "", caption: "Rimorchio",
        colSpan: '4',
        colVisible: false,
        labelVisible: true,
        class: 'd-none',
        visible: false,
        dynamic: {
          dataSource: 'Automezzo?id=',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          queryString: '',
          filterStatic: "?$filter=( tipoautomezzo eq 'D' )",
          componentType: 'grid',
          related: ['targa|rimorchio_Targa'], //


        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idTrasportatoreAlboCategoria",
        class: 'd-none',
        visible: false,

        dynamic: {
          valueExpr: 'id',
          displayExpr: '',
          dataSource: 'AlboCategoria',
          autocomplete: false,


        }

      },
      {
        type: 'campo', colVisible: false, dataField: "idTestoADR",
        caption: "ADR",
        dataType: '',
        class: 'd-none',
        visible: false,
        colSpan: '5',

      },
      {
        type: 'campo', colVisible: false, dataField: "idLotto",
        class: 'd-none',
        visible: false,
        colSpan: '5'
      },
      {
        type: 'campo', colVisible: false, dataField: "idLotto_Sede",
        class: 'd-none',
        visible: false,
        colSpan: '5'
      },
      {
        type: 'campo',
        dataField: 'idImballo',
        caption: 'Imballo',
        class: 'imballo d-none',
        visible: false,
        colVisible: false


      },
      {
        type: 'campoHidden', colVisible: false, dataField: "idCategoriaDocumento",
        colSpan: 4,
        class: 'd-none',
        visible: false,
        dynamic: {

          costantValue: [{ key: 'nomeTabella', value: 'movimenti' }],
          queryString: '?nomeTabella=movimenti',
          dataSource: 'Categoria',
          valueExpr: 'id',
          displayExpr: '',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista CategoriaDocumento",
          componentType: 'grid',
          related: ['descrizione|categoriaDocumento_Descrizione'],


        }

      },

    ]
  },

]
export const grigliaMovimentiRegistro: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", data: [
      {
        type: 'campo', dataField: "descrizioneCausaleRentri", caption: 'Operazione Rentri',
        showEditorAlways: false,
        allowEditing: false,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        class: '',
      },
      {
        type: 'campo', dataField: "causaleRentri", caption: 'Causale',
        showEditorAlways: false,
        allowEditing: false,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        class: '',
        colWidth: '40',
      },
      {
        type: 'campo', dataField: "descrizioneRegistro", caption: 'Registro',
        showEditorAlways: false,
        allowEditing: false,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        class: '',
      },
      {
        type: 'campo', dataField: "tipoRegistro", caption: 'Tipo',
        showEditorAlways: false,
        allowEditing: false,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        class: '',
        lista: {
          static: true,
          dataSource: '',
          valueExpr: 'key',
          displayExpr: 'label',
          items: [
            { key: 'C', label: 'Carico' },
            { key: 'S', label: 'Scarico' },
            { key: 'T', label: 'Trasporto' },
            { key: 'I', label: 'Intermediaz.' },
          ]

        }
      },
    ]
  }
  // "id": 0,
  // "idMovimento": null,
  // "idRegistro": 1,
  // "descrizioneRegistro": "REGISTRO  produzione",
  // "tipoRegistro": null,
  // "causaleRentri": "DT",
  // "descrizioneCausaleRentri": "Prodotto o detenuto nell'unità locale",
  // "versione": 0

]
export const giacenzePanelMovimenti: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'giacenzePanelMovimenti',
      titleForm: 'giacenzePanelMovimenti ',
      breadcrumbCaption: '',
      campoTitle: null,
      service: 'giacenzePanelMovimenti',
      api: 'giacenzePanelMovimenti',
      filterList: '',
      filterEditor: '',
      helpDoc: '',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 1,


    }

  },

  {
    itemType: "group", groupDataField: '', class: '', colCount: "2", caption: 'Filtra Giacenze:', data: [

      {
        type: 'campoSpecial', dataField: "ListIdMagazzino", dataType: "", caption: "Magazzini",
        colVisible: false,
        width: '25vw',
        colSpan: '1',
        editorType: 'dxTagBox',
        disableOnUpdate: true,
        tagBoxList: {
          dataSource: 'MagazzinoRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?idSede=$idProduttore',
          showSelectionControls: true,
          maxDisplayedTags: 3,
          multiline: false,
        }
      },
      { type: 'empty', caption: "" },

      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Riferimento",
        colVisible: false,
        colSpan: '1',
        disableOnUpdate: true,
        class: 'd-none'

      },
      {
        type: 'campo', dataField: "isCerPericoloso", dataType: "", caption: "isCerPericoloso",
        colVisible: false,
        colSpan: '1',
        disableOnUpdate: true,
        class: 'd-none'

      },
      {
        type: 'campo', dataField: "riferimentoEERT", dataType: "", caption: "Mostra tutti Rif.EER",
        colVisible: false,
        width: 12 + 'vw',
        colSpan: '1',
        editorType: 'dxCheckBox',
        class: 'ms-4 d-none'
      },



    ],
  },


  /*  {
     itemType: "group", caption: '', colCount: "1",
     groupDataField: 'giacenzePanelGriglia',
     data: [
 
       {
         type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'listaGiacenzaRifiuti',
         colVisible: false,
         dynamic: {
           dataSource: "GiacenzaRifiuti",
           service: '',
           autocomplete:false,
           valueExpr: '',
           displayExpr: '',
           searchExpr: '',
           caption: "",
           filterStatic: '',
           componentType: 'dynamicGrid',
           settingGrid: {
             masterKey: 'id',
             keyUnique: '',
             mode: 'null',
             selectionMode: 'single',
             remoteOperations: false,
             hoverStateEnabled: true,
             rowAlternationEnabled: true,
             showFilterSearch: false,
             repaintChangesOnly: true,
             allowUpdating: false,
             allowDeleting: false,
             allowAdding: false,
             height: 430,
             showColBlank: false,
             colonne: [
               {
                 dataField: 'id',
                 dataType: '',
                 caption: '',
                 allowEditing: false,
                 colWidth: '40px'
               },              
               {
                 dataField: 'eer',
                 dataType: '',
                 caption: 'EER',
                 allowEditing: false,
                 colWidth: '66px'
               },
               {
                 dataField: 'idStatoFisico',
                 dataType: '',
                 caption: 'SF',
                 allowEditing: false,
                 colWidth: '42px'
               },
                            
               {
                 dataField: 'carico',
                 dataType: '',
                 caption: 'Carico',
                 allowEditing: false,
                 colWidth: '90px'
               },
               {
                 dataField: 'scaricoInterno',
                 dataType: '',
                 caption: 'Scarico',
                 allowEditing: false,
                 colWidth: '90px'
               },
               {
                 dataField: 'scaricoATerzi',
                 dataType: '',
                 caption: 'Scar.Terzi',
                 allowEditing: false,
                 colWidth: '90px'
               },
               {
                 dataField: 'giacenzaFinale',
                 dataType: '',
                 caption: 'Giac. Fin.',
                 allowEditing: false,
                 colWidth: '90px'
               },
       
       
               
             ],
       
           }
       
         }
       },
 
     ]
 
   }, */
]


let movimentiRifiutoMd = JSON.parse(JSON.stringify(movimentiRifiuto));
movimentiRifiutoMd = movimentiRifiutoMd.filter(resCol => {

  if (typeof resCol.data != 'undefined') {

    let data = resCol.data.filter(d => {

      d.allowFiltering = false;

      switch (d.dataField) {
        case 'isRentri':
          d.colVisible = false;
          break;
        case 'copiaComeNuovo':
          d.colVisible = false;
          break;
        case 'causale_Descrizione':
          d.colWidth = 400
          //d.allowFiltering = false;
          break;
        case 'produttore_Descrizione_Soggetto':
          d.colWidth = 300;
          d.caption = 'Produttore'
          d.colVisible = true;

          break
        case 'dataRegistrazione':
          d.colWidth = 100;
          d.allowFiltering = false;
          break
        case 'eer':
          d.colWidth = 70;
          d.dynamic.valueExpr = ''
          d.dynamic.displayExpr = 'id'
          break
        case 'numeroFormulario':
          d.colWidth = 150;

          break
        case 'quantitaKg':
          d.colWidth = 90;
          d.allowFiltering = false;
          break
        case 'riferimentoEER':
          d.colWidth = 85;

          break
        case 'mostraScaricoR':
          d.colVisible = false
          d.allowFiltering = false;
        default:
          break;
      }


      return d

    })

    resCol.data = data
    return resCol
  }
})

let movimentiRifiutoPr = JSON.parse(JSON.stringify(movimentiRifiuto))
movimentiRifiutoPr = movimentiRifiutoPr.filter(resCol => {
  if (typeof resCol.data != 'undefined') {

    let data = resCol.data.filter(d => {

      if (d.colVisible && d.dataField != "mostraScaricoR") {
        return d
      }

    })

    resCol.data = data
    return resCol
  }
})

let movimentiRifiutoMdProtofollati = movimentiRifiutoPr;

export const FormulariDaMov: AnaColumn[] = movimentiRifiutoMd
export const FormulariDaMov2: AnaColumn[] = movimentiRifiutoMdProtofollati

